/**
 * SWFObject v1.4.4: Flash Player detection and embed - http://blog.deconcept.com/swfobject/
 *
 * SWFObject is (c) 2006 Geoff Stearns and is released under the MIT License:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * **SWFObject is the SWF embed script formerly known as FlashObject. The name was changed for
 *   legal reasons.
 */
if (typeof deconcept == "undefined") { var deconcept = new Object(); }
if (typeof deconcept.util == "undefined") { deconcept.util = new Object(); }
if (typeof deconcept.SWFObjectUtil == "undefined") { deconcept.SWFObjectUtil = new Object(); }
deconcept.SWFObject = function (_1, id, w, h, _5, c, _7, _8, _9, _a, _b) {
    if (!document.getElementById) { return; }
    this.DETECT_KEY = _b ? _b : "detectflash";
    this.skipDetect = deconcept.util.getRequestParameter(this.DETECT_KEY);
    this.params = new Object();
    this.variables = new Object();
    this.attributes = new Array();
    if (_1) { this.setAttribute("swf", _1); }
    if (id) { this.setAttribute("id", id); }
    if (w) { this.setAttribute("width", w); }
    if (h) { this.setAttribute("height", h); }
    if (_5) { this.setAttribute("version", new deconcept.PlayerVersion(_5.toString().split("."))); }
    this.installedVer = deconcept.SWFObjectUtil.getPlayerVersion();
    if (c) { this.addParam("bgcolor", c); }
    var q = _8 ? _8 : "high";
    this.addParam("quality", q);
    this.setAttribute("useExpressInstall", _7);
    this.setAttribute("doExpressInstall", false);
    var _d = (_9) ? _9 : window.location;
    this.setAttribute("xiRedirectUrl", _d);
    this.setAttribute("redirectUrl", "");
    if (_a) { this.setAttribute("redirectUrl", _a); }
};
deconcept.SWFObject.prototype = {
    setAttribute: function (_e, _f) {
        this.attributes[_e] = _f;
    }, getAttribute: function (_10) {
        return this.attributes[_10];
    }, addParam: function (_11, _12) {
        this.params[_11] = _12;
    }, getParams: function () {
        return this.params;
    }, addVariable: function (_13, _14) {
        this.variables[_13] = _14;
    }, getVariable: function (_15) {
        return this.variables[_15];
    }, getVariables: function () {
        return this.variables;
    }, getVariablePairs: function () {
        var _16 = new Array();
        var key;
        var _18 = this.getVariables();
        for (key in _18) { _16.push(key + "=" + _18[key]); }
        return _16;
    }, getSWFHTML: function () {
        var _19 = "";
        if (navigator.plugins && navigator.mimeTypes && navigator.mimeTypes.length) {
            if (this.getAttribute("doExpressInstall")) {
                this.addVariable("MMplayerType", "PlugIn");
            }
            _19 = "<embed type=\"application/x-shockwave-flash\" src=\"" + this.getAttribute("swf") + "\" width=\"" + this.getAttribute("width") + "\" height=\"" + this.getAttribute("height") + "\"";
            _19 += " id=\"" + this.getAttribute("id") + "\" name=\"" + this.getAttribute("id") + "\" ";
            var _1a = this.getParams();
            for (var key in _1a) { _19 += [key] + "=\"" + _1a[key] + "\" "; }
            var _1c = this.getVariablePairs().join("&");
            if (_1c.length > 0) { _19 += "flashvars=\"" + _1c + "\""; } _19 += "/>";
        } else {
            if (this.getAttribute("doExpressInstall")) { this.addVariable("MMplayerType", "ActiveX"); }
            _19 = "<object id=\"" + this.getAttribute("id") + "\" classid=\"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000\" width=\"" + this.getAttribute("width") + "\" height=\"" + this.getAttribute("height") + "\">";
            _19 += "<param name=\"movie\" value=\"" + this.getAttribute("swf") + "\" />";
            var _1d = this.getParams();
            for (var key in _1d) { _19 += "<param name=\"" + key + "\" value=\"" + _1d[key] + "\" />"; }
            var _1f = this.getVariablePairs().join("&");
            if (_1f.length > 0) { _19 += "<param name=\"flashvars\" value=\"" + _1f + "\" />"; } _19 += "</object>";
        }
        return _19;
    }, write: function (_20) {
        if (this.getAttribute("useExpressInstall")) {
            var _21 = new deconcept.PlayerVersion([6, 0, 65]);
            if (this.installedVer.versionIsValid(_21) && !this.installedVer.versionIsValid(this.getAttribute("version"))) {
                this.setAttribute("doExpressInstall", true);
                this.addVariable("MMredirectURL", escape(this.getAttribute("xiRedirectUrl")));
                document.title = document.title.slice(0, 47) + " - Flash Player Installation";
                this.addVariable("MMdoctitle", document.title);
            }
        }
        if (this.skipDetect || this.getAttribute("doExpressInstall") || this.installedVer.versionIsValid(this.getAttribute("version"))) {
            var n = (typeof _20 == "string") ? document.getElementById(_20) : _20;
            n.innerHTML = this.getSWFHTML(); return true;
        } else { if (this.getAttribute("redirectUrl") != "") { document.location.replace(this.getAttribute("redirectUrl")); } }
        return false;
    }
};
deconcept.SWFObjectUtil.getPlayerVersion = function () {
    var _23 = new deconcept.PlayerVersion([0, 0, 0]);
    if (navigator.plugins && navigator.mimeTypes.length) {
        var x = navigator.plugins["Shockwave Flash"];
        if (x && x.description) { _23 = new deconcept.PlayerVersion(x.description.replace(/([a-zA-Z]|\s)+/, "").replace(/(\s+r|\s+b[0-9]+)/, ".").split(".")); }
    } else {
        try { var axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7"); }
        catch (e) {
            try {
                var axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6");
                _23 = new deconcept.PlayerVersion([6, 0, 21]); axo.AllowScriptAccess = "always";
            }
            catch (e) { if (_23.major == 6) { return _23; } } try { axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash"); }
            catch (e) { }
        } if (axo != null) { _23 = new deconcept.PlayerVersion(axo.GetVariable("$version").split(" ")[1].split(",")); }
    }
    return _23;
};
deconcept.PlayerVersion = function (_27) {
    this.major = _27[0] != null ? parseInt(_27[0]) : 0;
    this.minor = _27[1] != null ? parseInt(_27[1]) : 0;
    this.rev = _27[2] != null ? parseInt(_27[2]) : 0;
};
deconcept.PlayerVersion.prototype.versionIsValid = function (fv) {
    if (this.major < fv.major) { return false; }
    if (this.major > fv.major) { return true; }
    if (this.minor < fv.minor) { return false; }
    if (this.minor > fv.minor) { return true; }
    if (this.rev < fv.rev) {
        return false;
    } return true;
};
deconcept.util = {
    getRequestParameter: function (_29) {
        var q = document.location.search || document.location.hash;
        if (q) {
            var _2b = q.substring(1).split("&");
            for (var i = 0; i < _2b.length; i++) {
                if (_2b[i].substring(0, _2b[i].indexOf("=")) == _29) {
                    return _2b[i].substring((_2b[i].indexOf("=") + 1));
                }
            }
        }
        return "";
    }
};
deconcept.SWFObjectUtil.cleanupSWFs = function () {
    if (window.opera || !document.all) { return; }
    var _2d = document.getElementsByTagName("OBJECT");
    for (var i = 0; i < _2d.length; i++) {
        _2d[i].style.display = "none"; for (var x in _2d[i]) {
            if (typeof _2d[i][x] == "function") { _2d[i][x] = function () { }; }
        }
    }
};
deconcept.SWFObjectUtil.prepUnload = function () {
    __flash_unloadHandler = function () { };
    __flash_savedUnloadHandler = function () { };
    if (typeof window.onunload == "function") {
        var _30 = window.onunload;
        window.onunload = function () {
            deconcept.SWFObjectUtil.cleanupSWFs(); _30();
        };
    } else { window.onunload = deconcept.SWFObjectUtil.cleanupSWFs; }
};
if (typeof window.onbeforeunload == "function") {
    var oldBeforeUnload = window.onbeforeunload;
    window.onbeforeunload = function () {
        deconcept.SWFObjectUtil.prepUnload();
        oldBeforeUnload();
    };
} else { window.onbeforeunload = deconcept.SWFObjectUtil.prepUnload; }
if (Array.prototype.push == null) {
    Array.prototype.push = function (_31) {
        this[this.length] = _31;
        return this.length;
    };
}
var getQueryParamValue = deconcept.util.getRequestParameter;
var FlashObject = deconcept.SWFObject;
var SWFObject = deconcept.SWFObject;var $NS = YAHOO.namespace('hover');

var hoverInfoArray = new Array();
var hoverStoryArray = new Array();
var hoverAudioArray = new Array();
var hoverVideoArray = new Array();

var ToShow;

var initHover = function() {
    $NS.hoverbox = new YAHOO.widget.Overlay("hoverbox", {
        visible: false,
        zIndex: 9999,
        width: "300px",
        //effect:{effect:YAHOO.widget.ContainerEffect.FADE,duration:0.5},
        //constraintoviewport:true,
        iframe: false,
        monitorresize: false
    });
    // These 3 lines that set the header, body and footer are done so that the hoverbox gets initialized
    // properly.  Otherwise, the first time it is rendered by the user hovering over an image, the height
    // does not get calculated correctly, and if it should be re-positioned upward because the image being
    // hovered over is at the bottom of the viewport, that doesn't happen the first time the user hovers.
    $NS.hoverbox.setHeader("title");
    $NS.hoverbox.setBody("addedby");
    $NS.hoverbox.setFooter("desc");

    var rendered = $NS.hoverbox.render(document.body);
};

var onHover = function(type, el, idx) {
    if ($NS.hoverbox != undefined) {
        var hoverArray;
        switch (type) {
            case 'audio':
                hoverArray = hoverAudioArray;
                break;
            case 'video':
                hoverArray = hoverVideoArray;
                break;
            case 'application':
                hoverArray = hoverStoryArray;
                break;
            case 'photo':
            default:
                hoverArray = hoverInfoArray;
                break;
        }
        var knob = "knob-lt";
        var hoverLeft = YAHOO.util.Dom.getX(el) + el.offsetWidth + 3;
        var viewWidth = YAHOO.util.Dom.getViewportWidth() + document.documentElement.scrollLeft;
        if ((hoverLeft + 240) > viewWidth) {
            hoverLeft = hoverLeft - 322 - 8 * 2 - el.offsetWidth + 10; // -1;
            knob = "knob-rt";
        }
        $NS.hoverbox.setHeader("<span class=\"" + knob + "\"><span></span></span><h4>" + hoverArray[idx].name + "</h4>");

        var bodySection = '';
        // set the "added by" - using the body
        if (hoverArray[idx].addedby != undefined) {
            bodySection = hoverArray[idx].addedby;
        }

        // set the description
        if (hoverArray[idx].desc != undefined) {
            var desc = hoverArray[idx].desc.substring(0, 200);
            if (desc.length < hoverArray[idx].desc.length) desc += "...";
            bodySection = bodySection + '<br /><br />' + desc;
        }
        $NS.hoverbox.setBody(bodySection);

        // use the footer for community type information
        var footerSection = '';
        if (hoverArray[idx].copied != undefined) {
            // list other users who copied this object to their tree
            footerSection = hoverArray[idx].copied.title;
            var copiers = hoverArray[idx].copied.copiers;
            for (var i = 0; i < copiers.length; i++) {
                footerSection += "<br />" + copiers[i];
            }
            if (hoverArray[idx].copied.more != undefined) {
                footerSection += "<br />" + hoverArray[idx].copied.more;
            }
        }
        if (hoverArray[idx].comments != undefined) {
            footerSection += "<br />" + hoverArray[idx].comments;
        }
        $NS.hoverbox.setFooter(footerSection);

        var hoverTop = YAHOO.util.Dom.getY(el) + 10;
        var viewHeight = YAHOO.util.Dom.getViewportHeight() + document.documentElement.scrollTop;
        var hoverHeight = document.getElementById("hoverbox").offsetHeight;

        var overlap = (hoverTop + hoverHeight) - viewHeight;
        if (overlap > 0) {
            hoverTop = viewHeight - hoverHeight - 8;
            if (overlap > 20) {
                knob = knob.substring(0, knob.length - 1) + "b"; // switch the knob to the bottom
                $NS.hoverbox.setHeader("<span class=\"" + knob + "\"><span></span></span><h4>" + hoverArray[idx].name + "</h4>");
            }
        }

        $NS.hoverbox.cfg.setProperty("xy", [hoverLeft, hoverTop]);
        $NS.hoverbox.render(document.body);


        //        $NS.hoverbox.cfg.setProperty("visible", true);
        $NS.hoverbox.cfg.setProperty("visible", false);


        //Deal with setting up mouseover and mouseout to hoverbox
        removeListnr();
        hoverBoxLstnr();
    }
};

var hoverboxitem = null;
var version = navigator.userAgent;
var findIE7 = version.indexOf('MSIE 7');

var hoverBoxLstnr = function() {
    hoverboxitem = document.getElementById('hoverbox');

    if (hoverboxitem != null) {
        if (findIE7 != -1) {
            clearHoverboxTimer();
            hoverboxitem.setAttribute("onmouseover", "javscript:clearHoverboxTimer();");
            hoverboxitem.setAttribute("onmouseout", "javscript:clearHoverboxTimer();javscript:hoverboxTimeout();");
            hoverboxitem.onmouseover = "javscript:clearHoverboxTimer();";
            hoverboxitem.onmouseout = "javscript:clearHoverboxTimer();javscript:hoverboxTimeout();";

            YAHOO.util.Event.addListener("hoverbox", "mouseover", clearHoverboxTimer);
//            YAHOO.util.Event.addListener(document, "mousedown", offHover);
            YAHOO.util.Event.addListener("hoverbox", "mouseout", hoverboxTimeout);
        }
        else {
            hoverboxitem.setAttribute("onmouseover", "javscript:clearHoverboxTimer();");
            hoverboxitem.setAttribute("onmouseout", "javscript:clearHoverboxTimer();javscript:hoverboxTimeout();");
        }

        hoverboxitem.style.zIndex = "9999";
    }
};

var removeListnr = function() {
    if (findIE7 != -1) {
        YAHOO.util.Event.removeListener("hoverbox", "mouseover", clearHoverboxTimer);
        YAHOO.util.Event.removeListener("hoverbox", "mouseout", hoverboxTimeout);
    }
    hoverboxitem = null;
};

var offHover = function() {
    removeListnr();
    if ($NS.hoverbox != undefined) {
        $NS.hoverbox.cfg.setProperty("visible", false);
    }
};

var timerHB = 0;

var clearHoverboxTimer = function() {
    if (timerHB != 0 && timerHB != null) {
        clearTimeout(timerHB);
        timerHB = 0;
        ToShow = setTimeout(function() {
            if ($NS.hoverbox != undefined) {
                $NS.hoverbox.cfg.setProperty("visible", true);
            }
        }, 100);
    }
};

var hoverboxTimeout = function() {
    timerHB = setTimeout(function() {
        clearTimeout(ToShow);
        ToShow = 0;
        removeListnr();
        if ($NS.hoverbox != undefined) {
            $NS.hoverbox.cfg.setProperty("visible", false);
        }
    }, 500);
};TreesCarousel = function(hashData)
{
	this.init(hashData);
	initHover();
};

TreesCarousel.prototype = {

	init: function(hashData) {
		this.ajaxHandler = hashData.ajaxHandler;
		this.ajaxParams = hashData.ajaxParams != undefined ? hashData.ajaxParams : "";
		this.treeId = hashData.treeId;
		this.personId = hashData.personId;
		this.userId = hashData.userId;
		this.userName = hashData.userName;
		this.ancestryDomain = hashData.ancestryDomain;
		this.treesDomain = hashData.treesDomain;
		this.currPgArgs = hashData.currPgArgs;
		this.rightArrow = hashData.rightArrow;
		this.rightArrowDisabled = hashData.rightArrowDisabled;
		this.leftArrow = hashData.leftArrow;
		this.leftArrowDisabled = hashData.leftArrowDisabled;
		this.audioIcon = hashData.audioIcon;
		this.showTitle = hashData.showTitle;
		this.addPhotoImg = hashData.addPhotoImg;
		this.addPhotoUrl = hashData.addPhotoUrl;
		this.viewId = hashData.viewId;
		this.isReadonly = hashData.isReadonly;
		this.totalCount = hashData.totalCount;
		this.useIndex = hashData.useIndex != undefined ? hashData.useIndex : true;
	},
	loadInitialAudioAjax: function (type, args)
	{
		alert("here");
		var start = args[0];
		var last = args[1]; 
		// fetch thrice the number needed and cache them.
		ajaxFetchItems(this, start, last, 'audio');
	}
	
};

// AJAX versions of load handlers - items retrieved through asynch ajax call
// loadInitHandler - load the initial set of items for the carousel
var loadInitialPhotosAjax = function (type, args)
{
	var cnt = photoTreesCarousel.totalCount;
	if (photoTreesCarousel.addPhotoUrl != undefined && photoTreesCarousel.addPhotoUrl.length > 0)
	{
		var numVisible = this.cfg.getProperty("numVisible");
		if (cnt < numVisible) cnt++;
	}
	loadInitialAjax(this, type, args, 'photo', cnt);
};
// loadNextHandler - load the next set of data items
var loadNextPhotosAjax = function (type, args)
{
	loadAjax(this, type, args, 'photo');
};
// loadPrevHandler - loads the previous set of data items
var loadPrevPhotosAjax = function (type, args)
{
	loadAjax(this, type, args, 'photo');
};
var loadInitialAudioAjax = function (type, args)
{
	loadInitialAjax(this, type, args, 'audio', audioTreesCarousel.totalCount);
};
// loadNextHandler - load the next set of data items
var loadNextAudioAjax = function (type, args)
{
	loadAjax(this, type, args, 'audio');
};
// loadPrevHandler - loads the previous set of data items
var loadPrevAudioAjax = function (type, args)
{
	loadAjax(this, type, args, 'audio');
};
var loadInitialVideoAjax = function (type, args)
{
	loadInitialAjax(this, type, args, 'video', videoTreesCarousel.totalCount);
};
// loadNextHandler - load the next set of data items
var loadNextVideoAjax = function (type, args)
{
	loadAjax(this, type, args, 'video');
};
// loadPrevHandler - loads the previous set of data items
var loadPrevVideoAjax = function (type, args)
{
	loadAjax(this, type, args, 'video');
};
// generic function to loadInitial by Ajax
var loadInitialAjax = function (carousel, type, args, objType, count)
{
	var start = args[0];
	var last = args[1]; 
	ajaxFetchItems(carousel, start, last, objType);
	carousel.cfg.setProperty("size", parseInt(count), true);
};
// generic function to load by Ajax (loadNext & loadPrev)
var loadAjax = function (carousel, type, args, objType)
{
	var start = args[0];
	var last = args[1]; 
	var alreadyCached = args[2];
	if (!alreadyCached)
	{
		ajaxFetchItems(carousel, start, last, objType);	
	}
};

// do the ajax call to get items (photos, etc)
// start:	where to start placing the next items retrieved in the overall list.
// last:	the index of the last item about to be display by the carousel.
var ajaxFetchItems = function (carousel, start, last, type)
{
	var numVisible = carousel.cfg.getProperty("numVisible");
	//var numResults = numVisible*3;		// get 3 times the carousel size for efficiency
	var numResults = numVisible; 	// only get as many as might be needed to reduce the overall number of requests for a page
	var sUrl = "";
	switch (type)
	{
		case 'photo':
			sUrl = $trees.util.getAjaxUrlPrefix() + "/" + photoTreesCarousel.ajaxHandler + "?typ=ph&tid=" + photoTreesCarousel.treeId + "&pid=" + photoTreesCarousel.personId + "&uid=" + photoTreesCarousel.userId + "&unm=" + photoTreesCarousel.userName + "&beg=" + start + "&num=" + numResults + photoTreesCarousel.ajaxParams;
			if (photoTreesCarousel.addPhotoImg != undefined && photoTreesCarousel.isReadonly != true)
			{
				sUrl += "&addi=1&sz=" + carousel.cfg.getProperty("numVisible");	// include a parameter to let the ajax handler know to include an image to link to "add photo" when the carousel is not full
			}
			if (photoTreesCarousel.viewId != undefined)
			{
				sUrl += "&vid=" + photoTreesCarousel.viewId;
			}
			break;
		case 'audio':
		    sUrl = $trees.util.getAjaxUrlPrefix() + "/" + audioTreesCarousel.ajaxHandler + "?typ=au&tid=" + audioTreesCarousel.treeId + "&pid=" + audioTreesCarousel.personId + "&uid=" + audioTreesCarousel.userId + "&unm=" + audioTreesCarousel.userName + "&beg=" + start + "&num=" + numResults + photoTreesCarousel.ajaxParams;
			break;
		case 'video':
		    sUrl = $trees.util.getAjaxUrlPrefix() + "/" + videoTreesCarousel.ajaxHandler + "?typ=vi&tid=" + videoTreesCarousel.treeId + "&pid=" + videoTreesCarousel.personId + "&uid=" + videoTreesCarousel.userId + "&unm=" + videoTreesCarousel.userName + "&beg=" + start + "&num=" + numResults + photoTreesCarousel.ajaxParams;
			break;
	}
	var callback = {
		success: handleSuccess,
		failure: handleFailure,
		argument: [start, last, carousel]
	};
	YAHOO.util.Connect.asyncRequest("GET", sUrl, callback, null);
};

// process the successful return of data from ajaxFetchItems
var handleSuccess = function(callbackResponse)
{
	var start = callbackResponse.argument[0];
	var last = callbackResponse.argument[1];
	var carousel = callbackResponse.argument[2];

	if (callbackResponse.responseText != undefined)
	{
		var res = eval( '(' + callbackResponse.responseText + ')' );
		var hoverArray=hoverInfoArray;
		var itemsInList = 0;

		for (var i=0; i < res.whatsnew.objects.length; i++)
		{
			var item = res.whatsnew.objects[i];
			var x = parseInt(start) + i;
			carousel.addItem(x, fmtInnerHTML(x, item.type, item.name, item.tid, item.pid, item.oid, item.url));
			switch (item.type)
			{
				case 'audio':
					hoverArray=hoverAudioArray;
					break;
				case 'video':
					hoverArray=hoverVideoArray;
					break;
				case 'photo':
				default:
					hoverArray=hoverInfoArray;
					break;
			}
			
			hoverArray[x] = item;
			itemsInList++;
		}

		showButtons(carousel);
	}
};
// process the failure of the ajaxFetchItems call
var handleFailure = function(o) { };

//// loadInitialItems - load the initial set of items for the carousel from a javascript array
//var loadInitialItems = function(type, args) {
//	var start = args[0];
//	var last = args[1]; 
//	loadItems(this, 1, last+1);
//};
//// loadNextHandler - load more data items (either next or previous) from a javascript array
//var loadPrevItems = function(type, args) {
//	var start = args[0];
//	var last = args[1]; 
//	var alreadyCached = args[2];
//	if (!alreadyCached)
//	{
//		loadItems(this, start, last);
//	}
//};
//// loadNextHandler - load more data items (either next or previous) from a javascript array
//var loadNextItems = function(type, args) {
//	var start = args[0];
//	var last = args[1]; 
//	var alreadyCached = args[2];
//	if (!alreadyCached)
//	{
//		loadItems(this, start, last);
//	}
//};
//// loadItems
//var loadItems = function(carousel, start, last)
//{
//	if (last >= objList.length)
//	{
//		last = objList.length;
//	}
//	carousel.cfg.setProperty("size", objList.length, true);
//    for(var i=start; i<=last; i++) {
//        addCarouselItem(carousel, i, objList[i-1][0], objList[i-1][1], objList[i-1][2], objList[i-1][3], objList[i-1][4], objList[i-1][5], objList[i-1][6]);
//    }
//	showButtons(carousel);
//};
//var objList = new Array();

//var addCarouselItem = function (carousel, index, itemType, itemTitle, itemDesc, addedBy, pid, oid, url)
//{
//	carousel.addItem(index, fmtInnerHTML(index, itemType, itemTitle, pid, oid, url));
//	addHoverInfo(index, itemTitle, itemDesc, addedBy); 
//};

var addHoverInfo = function (idx, title, desc, addedby)
{
	var item = {"name":title,"desc":desc,"addedby":addedby};
	hoverInfoArray[idx] = item;
};

var fmtInnerHTML = function(idx, type, name, tid, pid, oid, url)
{
	var urlPg = '/pt/ViewPhoto.aspx';
	var lnkUrl = '';
	var imgClass = "thumb";
	switch (type)
	{
		case 'image':
			var oidArg = '';
			if (oid == undefined)
			{
				if (photoTreesCarousel.addPhotoUrl != undefined)
				{
					urlPg = photoTreesCarousel.addPhotoUrl;
				}
				else
				{
					urlPg = '/pt/UploadPhoto.aspx';
				}
				url = photoTreesCarousel.addPhotoImg;
			}
			else
			{
				urlPg = '/pt/ViewPhoto.aspx';
				oidArg = '&oid=' + oid;
			}
			lnkUrl = 
				photoTreesCarousel.treesDomain + urlPg +
				'?tid=' + tid + 
				'&pid=' + pid +
				oidArg + 
				photoTreesCarousel.currPgArgs;
			if (photoTreesCarousel.useIndex) lnkUrl += "&idx="+idx;
			if (photoTreesCarousel.viewId != undefined) lnkUrl += "&vid="+photoTreesCarousel.viewId;
			break;
		case 'audio':
			urlPg = '/pt/ViewAudio.aspx';
			lnkUrl = 
				audioTreesCarousel.treesDomain + urlPg +
				'?tid=' + tid + 
				'&pid=' + pid +
				'&oid=' + oid + 
				audioTreesCarousel.currPgArgs;
			url = audioTreesCarousel.audioIcon;
			imgClass = "thumbAudio";
			break;
		case 'video':
			urlPg = '/pt/Video/ViewVideo.aspx';
			lnkUrl = 
				videoTreesCarousel.treesDomain + urlPg +
				'?tid=' + tid + 
				'&pid=' + pid +
				'&oid=' + oid + 
				videoTreesCarousel.currPgArgs;
			break;
		case 'story':
			urlPg = '/pt/ViewStory.aspx';
			break;
		case 'record':
			urlPg = '/pt/ViewRecordRedir.aspx';
			break;
	}
		
	var innerHTML = '<img onmouseover="javascript:onHover(\'' + type + '\', this, \'' + idx + '\');javscript:clearHoverboxTimer();" onmouseout="javscript:hoverboxTimeout();" src="' + url + '" />';
		var titleHTML = '';
		if (photoTreesCarousel.showTitle)
		{
			var title = name;
			if (title.length > 32)
			{
				title = title.substring(0, 29) + "...";
			}
			titleHTML = '<span class="thumb-title">' + title + '</span>';
		}
	return innerHTML + titleHTML;
    
};

var handlePrevPhotosButtonState = function(type, args)
{
	var enabling = args[0];
	var leftImage = args[1];
	if (photoTreesCarousel != null && leftImage != null)
	{
		if(enabling) {
			leftImage.src = photoTreesCarousel.leftArrow;
			leftImage.className = "left-button-image";
		} else {
			leftImage.src = photoTreesCarousel.leftArrowDisabled;
			leftImage.className = "left-button-inactive";
		}
	}
};

var handleNextPhotosButtonState = function(type, args)
{
	var enabling = args[0];
	var rightImage = args[1];
	if (photoTreesCarousel != null)
	{
		if(enabling) {
			rightImage.src = photoTreesCarousel.rightArrow;
			rightImage.className = "right-button-image";
		} else {
			rightImage.src = photoTreesCarousel.rightArrowDisabled;
			rightImage.className = "right-button-inactive";
		}
	}
};
var handlePrevAudioButtonState = function(type, args)
{
	var enabling = args[0];
	var leftImage = args[1];
	if (audioTreesCarousel != null && leftImage != null)
	{
		if(enabling) {
			leftImage.src = audioTreesCarousel.leftArrow;
			leftImage.className = "left-button-image";
		} else {
			leftImage.src = audioTreesCarousel.leftArrowDisabled;
			leftImage.className = "left-button-inactive";
		}
	}
};

var handleNextAudioButtonState = function(type, args)
{
	var enabling = args[0];
	var rightImage = args[1];
	if (audioTreesCarousel != null)
	{
		if(enabling) {
			rightImage.src = audioTreesCarousel.rightArrow;
			rightImage.className = "right-button-image";
		} else {
			rightImage.src = audioTreesCarousel.rightArrowDisabled;
			rightImage.className = "right-button-inactive";
		}
	}
};

var handlePrevVideoButtonState = function(type, args)
{
	var enabling = args[0];
	var leftImage = args[1];
	if (videoTreesCarousel != null && leftImage != null)
	{
		if(enabling) {
			leftImage.src = videoTreesCarousel.leftArrow;
			leftImage.className = "left-button-image";
		} else {
			leftImage.src = videoTreesCarousel.leftArrowDisabled;
			leftImage.className = "left-button-inactive";
		}
	}
};

var handleNextVideoButtonState = function(type, args)
{
	var enabling = args[0];
	var rightImage = args[1];
	if (videoTreesCarousel != null)
	{
		if(enabling) {
			rightImage.src = videoTreesCarousel.rightArrow;
			rightImage.className = "right-button-image";
		} else {
			rightImage.src = videoTreesCarousel.rightArrowDisabled;
			rightImage.className = "right-button-inactive";
		}
	}
};

var showButtons = function(carousel)
{
	var nextElement = carousel.cfg.getProperty("nextElement");
	var prevElement = carousel.cfg.getProperty("prevElement");
	var itemCount = carousel.cfg.getProperty("size");
	var numVisible = carousel.cfg.getProperty("numVisible");
	if (itemCount <= numVisible)
	{
		YAHOO.util.Dom.setStyle(nextElement, "visibility", "hidden");
		YAHOO.util.Dom.setStyle(prevElement, "visibility", "hidden");
	} else
	{
		YAHOO.util.Dom.setStyle(nextElement, "visibility", "visible");
		YAHOO.util.Dom.setStyle(prevElement, "visibility", "visible");
	}
};
/**
 * Copyright (c) 2006-2007, Bill W. Scott
 * All rights reserved.
 *
 * This work is licensed under the Creative Commons Attribution 2.5 License. To view a copy 
 * of this license, visit http://creativecommons.org/licenses/by/2.5/ or send a letter to 
 * Creative Commons, 543 Howard Street, 5th Floor, San Francisco, California, 94105, USA.
 *
 * This work was created by Bill Scott (billwscott.com, looksgoodworkswell.com).
 * 
 * The only attribution I require is to keep this notice of copyright & license 
 * in this original source file.
 *
 * Version 0.6.1 - 07.08.2007
 *
 */
YAHOO.namespace("extension");

/**
* @class 
* The carousel class manages a content list (a set of LI elements within an UL list)  that can be displayed horizontally or vertically. The content can be scrolled back and forth  with or without animation. The content can reference static HTML content or the list items can  be created dynamically on-the-fly (with or without Ajax). The navigation and event handling  can be externalized from the class.
* @param {object|string} carouselElementID The element ID (id name or id object) of the DIV that will become a carousel
* @param {object} carouselCfg The configuration object literal containing the configuration that should be set for this module. See configuration documentation for more details.
* @constructor
*/
YAHOO.extension.Carousel = function(carouselElementID, carouselCfg) {
 		this.init(carouselElementID, carouselCfg);
	};

	YAHOO.extension.Carousel.prototype = {


		/**
		* Constant denoting that the carousel size is unbounded (no limits set on scrolling)
		* @type number
		*/
		UNBOUNDED_SIZE: 1000000,

		/**
		* Initializes the carousel object and all of its local members.
		* @param {object|string} carouselElementID The element ID (id name or id object) 
		* of the DIV that will become a carousel
		* @param {object} carouselCfg The configuration object literal containing the 
		* configuration that should be set for this module. See configuration documentation for more details.
		*/
		init: function (carouselElementID, carouselCfg) {

			var oThis = this;

			/**
			* For deprecation.
			* getItem is the replacement for getCarouselItem
			*/
			this.getCarouselItem = this.getItem;

			// CSS style classes
			var carouselListClass = "carousel-list";
			var carouselClipRegionClass = "carousel-clip-region";
			var carouselNextClass = "carousel-next";
			var carouselPrevClass = "carousel-prev";

			this._carouselElemID = carouselElementID;
			this.carouselElem = YAHOO.util.Dom.get(carouselElementID);

			this._prevEnabled = true;
			this._nextEnabled = true;

			// Create the config object
			this.cfg = new YAHOO.util.Config(this);

			/**
			* scrollBeforeAmount property. 
			* Normally, set to 0, this is how much you are allowed to
			* scroll below the first item. Setting it to 2 allows you
			* to scroll to the -1 position. 
			* However, the load handlers will not be asked to load anything
			* below 1.
			*
			* A good example is the spotlight example which treats the middle item
			* as the "selected" item. It sets scrollBeforeAmount to 2 and 
			* scrollAfterAmount to 2.
			*
			* The actual items loaded would be from 1 to 15 (size=15),
			* but scrolling range would be -1 to 17.
			*/
			this.cfg.addProperty("scrollBeforeAmount", {
				value: 0,
				handler: function (type, args, carouselElem) {
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* scrollAfterAmount property. 
			* Normally, set to 0, this is how much you are allowed to
			* scroll past the size. Setting it to 2 allows you
			* to scroll to the size+scrollAfterAmount position. 
			* However, the load handlers will not be asked to load anything
			* beyond size.
			*
			* A good example is the spotlight example which treats the middle item
			* as the "selected" item. It sets scrollBeforeAmount to 2 and 
			* scrollAfterAmount to 2.
			*
			* The actual items loaded would be from 1 to 15 (size=15),
			* but scrolling range would be -1 to 17.
			*/
			this.cfg.addProperty("scrollAfterAmount", {
				value: 0,
				handler: function (type, args, carouselElem) {
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* loadOnStart property. 
			* If true, will call loadInitHandler on startup.
			* If false, will not. Useful for delaying the initialization
			* of the carousel for a later time after creation.
			*/
			this.cfg.addProperty("loadOnStart", {
				value: true,
				handler: function (type, args, carouselElem) {
					// no action, only affects startup
				},
				validator: oThis.cfg.checkBoolean
			});

			/**
			* orientation property. 
			* Either "horizontal" or "vertical". Changes carousel from a 
			* left/right style carousel to a up/down style carousel.
			*/
			this.cfg.addProperty("orientation", {
				value: "horizontal",
				handler: function (type, args, carouselElem) {
					oThis.reload();
				},
				validator: function (orientation) {
					if (typeof orientation == "string") {
						return ("horizontal,vertical".indexOf(orientation.toLowerCase()) != -1);
					} else {
						return false;
					}
				}
			});

			/**
			* size property. 
			* The upper bound for scrolling in the 'next' set of content. 
			* Set to a large value by default (this means unlimited scrolling.) 
			*/
			this.cfg.addProperty("size", {
				value: this.UNBOUNDED_SIZE,
				handler: function (type, args, carouselElem) {
					oThis.reload();
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* numVisible property. 
			* The number of items that will be visible.
			*/
			this.cfg.addProperty("numVisible", {
				value: 3,
				handler: function (type, args, carouselElem) {
					oThis.reload();
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* firstVisible property. 
			* Sets which item should be the first visible item in the carousel. Use to set which item will
			* display as the first element when the carousel is first displayed. After the carousel is created,
			* you can manipulate which item is the first visible by using the moveTo() or scrollTo() convenience
			* methods. Can be < 1 or greater than size if the scrollBeforeAmount or scrollAmountAfter has been set
			* to non-zero values.
			*/
			this.cfg.addProperty("firstVisible", {
				value: 1,
				handler: function (type, args, carouselElem) {
					oThis.moveTo(args[0]);
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* scrollInc property. 
			* The number of items to scroll by. Think of this as the page increment.
			*/
			this.cfg.addProperty("scrollInc", {
				value: 3,
				handler: function (type, args, carouselElem) {
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* animationSpeed property. 
			* The time (in seconds) it takes to complete the scroll animation. 
			* If set to 0, animated transitions are turned off and the new page of content is 
			* moved immdediately into place.
			*/
			this.cfg.addProperty("animationSpeed", {
				value: 0.25,
				handler: function (type, args, carouselElem) {
					oThis.animationSpeed = args[0];
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* animationMethod property. 
			* The <a href="http://developer.yahoo.com/yui/docs/animation/YAHOO.util.Easing.html">YAHOO.util.Easing</a> 
			* method.
			*/
			this.cfg.addProperty("animationMethod", {
				value: YAHOO.util.Easing.easeOut,
				handler: function (type, args, carouselElem) {
				}
			});

			/**
			* animationCompleteHandler property. 
			* JavaScript function that is called when the Carousel finishes animation 
			* after a next or previous nagivation. 
			* Only invoked if animationSpeed > 0. 
			* Two parameters are passed: type (set to 'onAnimationComplete') and 
			* args array (args[0] = direction [either: 'next' or 'previous']).
			*/
			this.cfg.addProperty("animationCompleteHandler", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._animationCompleteEvt) {
						oThis._animationCompleteEvt.unsubscribe(oThis._currAnimationCompleteHandler, oThis);
					}
					oThis._currAnimationCompleteHandler = args[0];
					if (oThis._currAnimationCompleteHandler) {
						if (!oThis._animationCompleteEvt) {
							oThis._animationCompleteEvt = new YAHOO.util.CustomEvent("onAnimationComplete", oThis);
						}
						oThis._animationCompleteEvt.subscribe(oThis._currAnimationCompleteHandler, oThis);
					}
				}
			});

			/**
			* autoPlay property. 
			* Specifies how many milliseconds to periodically auto scroll the content. 
			* If set to 0 (default) then autoPlay is turned off. 
			* If the user interacts by clicking left or right navigation, autoPlay is turned off. 
			* You can restart autoPlay by calling the <em>startAutoPlay()</em>. 
			* If you externally control navigation (with your own event handlers) 
			* then you may want to turn off the autoPlay by calling<em>stopAutoPlay()</em>
			*/
			this.cfg.addProperty("autoPlay", {
				value: 0,
				handler: function (type, args, carouselElem) {
					var autoPlay = args[0];
					if (autoPlay > 0)
						oThis.startAutoPlay();
					else
						oThis.stopAutoPlay();
				}
			});

			/**
			* wrap property. 
			* Specifies whether to wrap when at the end of scrolled content. When the end is reached,
			* the carousel will scroll backwards to the item 1 (the animationSpeed parameter is used to 
			* determine how quickly it should animate back to the start.)
			* Ignored if the <em>size</em> attribute is not explicitly set 
			* (i.e., value equals YAHOO.extension.Carousel.UNBOUNDED_SIZE)
			*/
			this.cfg.addProperty("wrap", {
				value: false,
				handler: function (type, args, carouselElem) {
				},
				validator: oThis.cfg.checkBoolean
			});

			/**
			* navMargin property. 
			* The margin space for the navigation controls. This is only useful for horizontal carousels 
			* in which you have embedded navigation controls. 
			* The <em>navMargin</em> allocates space between the left and right margins 
			* (each navMargin wide) giving space for the navigation controls.
			*/
			this.cfg.addProperty("navMargin", {
				value: 0,
				handler: function (type, args, carouselElem) {
					oThis.calculateSize();
				},
				validator: oThis.cfg.checkNumber
			});

			/**
			* revealAmount property. 
			* The amount to reveal of what comes before and what comes after the firstVisible and
			* the lastVisible items. Setting this will provide a slight preview that something 
			* exists before and after, providing an additional hint for the user.
			* The <em>revealAmount</em> will reveal the specified number of pixels for any item
			* before the firstVisible and an item after the lastVisible. Additionall, the
			* loadNextHandler and loadPrevHandler methods will be passed a start or end that guarantees
			* the revealed item will be loaded (if set to non-zero).
			*/
			this.cfg.addProperty("revealAmount", {
				value: 0,
				handler: function (type, args, carouselElem) {
					oThis.reload();
				},
				validator: oThis.cfg.checkNumber
			});

			// For backward compatibility. Deprecated.
			this.cfg.addProperty("prevElementID", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._carouselPrev) {
						YAHOO.util.Event.removeListener(oThis._carouselPrev, "click", oThis._scrollPrev);
					}
					oThis._prevElementID = args[0];
					if (oThis._prevElementID == null) {
						oThis._carouselPrev = YAHOO.util.Dom.getElementsByClassName(carouselPrevClass,
														"div", oThis.carouselElem)[0];
					} else {
						oThis._carouselPrev = YAHOO.util.Dom.get(oThis._prevElementID);
					}
					YAHOO.util.Event.addListener(oThis._carouselPrev, "click", oThis._scrollPrev, oThis);
				}
			});

			/**
			* prevElement property. 
			* An element or elements that will provide the previous navigation control.
			* prevElement may be a single element or an array of elements. The values may be strings denoting
			* the ID of the element or the object itself.
			* If supplied, then events are wired to this control to fire scroll events to move the carousel to
			* the previous content. 
			* You may want to provide your own interaction for controlling the carousel. If
			* so leave this unset and provide your own event handling mechanism.
			*/
			this.cfg.addProperty("prevElement", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._carouselPrev) {
						YAHOO.util.Event.removeListener(oThis._carouselPrev, "click", oThis._scrollPrev);
					}
					oThis._prevElementID = args[0];
					if (oThis._prevElementID == null) {
						oThis._carouselPrev = YAHOO.util.Dom.getElementsByClassName(carouselPrevClass,
														"div", oThis.carouselElem)[0];
					} else {
						oThis._carouselPrev = YAHOO.util.Dom.get(oThis._prevElementID);
					}
					YAHOO.util.Event.addListener(oThis._carouselPrev, "click", oThis._scrollPrev, oThis);
				}
			});

			// For backward compatibility. Deprecated.
			this.cfg.addProperty("nextElementID", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._carouselNext) {
						YAHOO.util.Event.removeListener(oThis._carouselNext, "click", oThis._scrollNext);
					}
					oThis._nextElementID = args[0];
					if (oThis._nextElementID == null) {
						oThis._carouselNext = YAHOO.util.Dom.getElementsByClassName(carouselNextClass,
														"div", oThis.carouselElem);
					} else {
						oThis._carouselNext = YAHOO.util.Dom.get(oThis._nextElementID);
					}
					if (oThis._carouselNext) {
						YAHOO.util.Event.addListener(oThis._carouselNext, "click", oThis._scrollNext, oThis);
					}
				}
			});

			/**
			* nextElement property. 
			* An element or elements that will provide the next navigation control.
			* nextElement may be a single element or an array of elements. The values may be strings denoting
			* the ID of the element or the object itself.
			* If supplied, then events are wired to this control to fire scroll events to move the carousel to
			* the next content. 
			* You may want to provide your own interaction for controlling the carousel. If
			* so leave this unset and provide your own event handling mechanism.
			*/
			this.cfg.addProperty("nextElement", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._carouselNext) {
						YAHOO.util.Event.removeListener(oThis._carouselNext, "click", oThis._scrollNext);
					}
					oThis._nextElementID = args[0];
					if (oThis._nextElementID == null) {
						oThis._carouselNext = YAHOO.util.Dom.getElementsByClassName(carouselNextClass,
														"div", oThis.carouselElem);
					} else {
						oThis._carouselNext = YAHOO.util.Dom.get(oThis._nextElementID);
					}
					if (oThis._carouselNext) {
						YAHOO.util.Event.addListener(oThis._carouselNext, "click", oThis._scrollNext, oThis);
					}
				}
			});

			/**
			* loadInitHandler property. 
			* JavaScript function that is called when the Carousel needs to load 
			* the initial set of visible items. Two parameters are passed: 
			* type (set to 'onLoadInit') and an argument array (args[0] = start index, args[1] = last index).
			*/
			this.cfg.addProperty("loadInitHandler", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._loadInitHandlerEvt) {
						oThis._loadInitHandlerEvt.unsubscribe(oThis._currLoadInitHandler, oThis);
					}
					oThis._currLoadInitHandler = args[0];
					if (oThis._currLoadInitHandler) {
						if (!oThis._loadInitHandlerEvt) {
							oThis._loadInitHandlerEvt = new YAHOO.util.CustomEvent("onLoadInit", oThis);
						}
						oThis._loadInitHandlerEvt.subscribe(oThis._currLoadInitHandler, oThis);
					}
				}
			});

			/**
			* loadNextHandler property. 
			* JavaScript function that is called when the Carousel needs to load 
			* the next set of items (in response to the user navigating to the next set.) 
			* Two parameters are passed: type (set to 'onLoadNext') and 
			* args array (args[0] = start index, args[1] = last index).
			*/
			this.cfg.addProperty("loadNextHandler", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._loadNextHandlerEvt) {
						oThis._loadNextHandlerEvt.unsubscribe(oThis._currLoadNextHandler, oThis);
					}
					oThis._currLoadNextHandler = args[0];
					if (oThis._currLoadNextHandler) {
						if (!oThis._loadNextHandlerEvt) {
							oThis._loadNextHandlerEvt = new YAHOO.util.CustomEvent("onLoadNext", oThis);
						}
						oThis._loadNextHandlerEvt.subscribe(oThis._currLoadNextHandler, oThis);
					}
				}
			});

			/**
			* loadPrevHandler property. 
			* JavaScript function that is called when the Carousel needs to load 
			* the previous set of items (in response to the user navigating to the previous set.) 
			* Two parameters are passed: type (set to 'onLoadPrev') and args array 
			* (args[0] = start index, args[1] = last index).
			*/
			this.cfg.addProperty("loadPrevHandler", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._loadPrevHandlerEvt) {
						oThis._loadPrevHandlerEvt.unsubscribe(oThis._currLoadPrevHandler, oThis);
					}
					oThis._currLoadPrevHandler = args[0];
					if (oThis._currLoadPrevHandler) {
						if (!oThis._loadPrevHandlerEvt) {
							oThis._loadPrevHandlerEvt = new YAHOO.util.CustomEvent("onLoadPrev", oThis);
						}
						oThis._loadPrevHandlerEvt.subscribe(oThis._currLoadPrevHandler, oThis);
					}
				}
			});

			/**
			* prevButtonStateHandler property. 
			* JavaScript function that is called when the enabled state of the 
			* 'previous' control is changing. The responsibility of 
			* this method is to enable or disable the 'previous' control. 
			* Two parameters are passed to this method: <em>type</em> 
			* (which is set to "onPrevButtonStateChange") and <em>args</em>, 
			* an array that contains two values. 
			* The parameter args[0] is a flag denoting whether the 'previous' control 
			* is being enabled or disabled. The parameter args[1] is the element object 
			* derived from the <em>prevElement</em> parameter.
			* If you do not supply a prevElement then you will need to track
			* the elements that you would want to enable/disable while handling the state change.
			*/
			this.cfg.addProperty("prevButtonStateHandler", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._currPrevButtonStateHandler) {
						oThis._prevButtonStateHandlerEvt.unsubscribe(oThis._currPrevButtonStateHandler, oThis);
					}

					oThis._currPrevButtonStateHandler = args[0];

					if (oThis._currPrevButtonStateHandler) {
						if (!oThis._prevButtonStateHandlerEvt) {
							oThis._prevButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onPrevButtonStateChange", oThis);
						}
						oThis._prevButtonStateHandlerEvt.subscribe(oThis._currPrevButtonStateHandler, oThis);
					}
				}
			});

			/**
			* nextButtonStateHandler property. 
			* JavaScript function that is called when the enabled state of the 
			* 'next' control is changing. The responsibility of 
			* this method is to enable or disable the 'next' control. 
			* Two parameters are passed to this method: <em>type</em> 
			* (which is set to "onNextButtonStateChange") and <em>args</em>, 
			* an array that contains two values. 
			* The parameter args[0] is a flag denoting whether the 'next' control 
			* is being enabled or disabled. The parameter args[1] is the element object 
			* derived from the <em>nextElement</em> parameter.
			* If you do not supply a nextElement then you will need to track
			* the elements that you would want to enable/disable while handling the state change.
			*/
			this.cfg.addProperty("nextButtonStateHandler", {
				value: null,
				handler: function (type, args, carouselElem) {
					if (oThis._currNextButtonStateHandler) {
						oThis._nextButtonStateHandlerEvt.unsubscribe(oThis._currNextButtonStateHandler, oThis);
					}
					oThis._currNextButtonStateHandler = args[0];

					if (oThis._currNextButtonStateHandler) {
						if (!oThis._nextButtonStateHandlerEvt) {
							oThis._nextButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onNextButtonStateChange", oThis);
						}
						oThis._nextButtonStateHandlerEvt.subscribe(oThis._currNextButtonStateHandler, oThis);
					}
				}
			});


			if (carouselCfg) {
				this.cfg.applyConfig(carouselCfg);
			}

			this._origFirstVisible = this.cfg.getProperty("firstVisible");

			// keep a copy of curr handler so it can be removed when a new handler is set
			this._currLoadInitHandler = this.cfg.getProperty("loadInitHandler");
			this._currLoadNextHandler = this.cfg.getProperty("loadNextHandler");
			this._currLoadPrevHandler = this.cfg.getProperty("loadPrevHandler");
			this._currPrevButtonStateHandler = this.cfg.getProperty("prevButtonStateHandler");
			this._currNextButtonStateHandler = this.cfg.getProperty("nextButtonStateHandler");
			this._currAnimationCompleteHandler = this.cfg.getProperty("animationCompleteHandler");

			this._nextElementID = this.cfg.getProperty("nextElementID");
			if (!this._nextElementID)
				this._nextElementID = this.cfg.getProperty("nextElement");

			this._prevElementID = this.cfg.getProperty("prevElementID");
			if (!this._prevElementID)
				this._prevElementID = this.cfg.getProperty("prevElement");

			this._autoPlayTimer = null;
			this._priorLastVisible = this._priorFirstVisible = this.cfg.getProperty("firstVisible");
			this._lastPrebuiltIdx = 0;
			// this._currSize = 0;

			// prefetch elements
			this.carouselList = YAHOO.util.Dom.getElementsByClassName(carouselListClass,
												"ul", this.carouselElem)[0];

			if (this._nextElementID == null) {
				this._carouselNext = YAHOO.util.Dom.getElementsByClassName(carouselNextClass,
												"div", this.carouselElem)[0];
			} else {
				this._carouselNext = YAHOO.util.Dom.get(this._nextElementID);
			}

			if (this._prevElementID == null) {
				this._carouselPrev = YAHOO.util.Dom.getElementsByClassName(carouselPrevClass,
												"div", this.carouselElem)[0];
			} else {
				this._carouselPrev = YAHOO.util.Dom.get(this._prevElementID);
			}

			this._clipReg = YAHOO.util.Dom.getElementsByClassName(carouselClipRegionClass,
												"div", this.carouselElem)[0];

			// add a style class dynamically so that the correct styles get applied for a vertical carousel
			if (this.isVertical()) {
				YAHOO.util.Dom.addClass(this.carouselList, "carousel-vertical");
			}

			// initialize the animation objects for next/previous
			this._scrollNextAnim = new YAHOO.util.Motion(this.carouselList, this.scrollNextParams,
   								this.cfg.getProperty("animationSpeed"), this.cfg.getProperty("animationMethod"));
			this._scrollPrevAnim = new YAHOO.util.Motion(this.carouselList, this.scrollPrevParams,
   								this.cfg.getProperty("animationSpeed"), this.cfg.getProperty("animationMethod"));

			// If they supplied a nextElementID then wire an event listener for the click
			if (this._carouselNext) {
				YAHOO.util.Event.addListener(this._carouselNext, "click", this._scrollNext, this);
			}

			// If they supplied a prevElementID then wire an event listener for the click
			if (this._carouselPrev) {
				YAHOO.util.Event.addListener(this._carouselPrev, "click", this._scrollPrev, this);
			}

			// Wire up the various event handlers that they might have supplied
			var loadInitHandler = this.cfg.getProperty("loadInitHandler");
			if (loadInitHandler) {
				this._loadInitHandlerEvt = new YAHOO.util.CustomEvent("onLoadInit", this);
				this._loadInitHandlerEvt.subscribe(loadInitHandler, this);
			}
			var loadNextHandler = this.cfg.getProperty("loadNextHandler");
			if (loadNextHandler) {
				this._loadNextHandlerEvt = new YAHOO.util.CustomEvent("onLoadNext", this);
				this._loadNextHandlerEvt.subscribe(loadNextHandler, this);
			}
			var loadPrevHandler = this.cfg.getProperty("loadPrevHandler");
			if (loadPrevHandler) {
				this._loadPrevHandlerEvt = new YAHOO.util.CustomEvent("onLoadPrev", this);
				this._loadPrevHandlerEvt.subscribe(loadPrevHandler, this);
			}
			var animationCompleteHandler = this.cfg.getProperty("animationCompleteHandler");
			if (animationCompleteHandler) {
				this._animationCompleteEvt = new YAHOO.util.CustomEvent("onAnimationComplete", this);
				this._animationCompleteEvt.subscribe(animationCompleteHandler, this);
			}
			var prevButtonStateHandler = this.cfg.getProperty("prevButtonStateHandler");
			if (prevButtonStateHandler) {
				this._prevButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onPrevButtonStateChange",
							this);
				this._prevButtonStateHandlerEvt.subscribe(prevButtonStateHandler, this);
			}
			var nextButtonStateHandler = this.cfg.getProperty("nextButtonStateHandler");
			if (nextButtonStateHandler) {
				this._nextButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onNextButtonStateChange", this);
				this._nextButtonStateHandlerEvt.subscribe(nextButtonStateHandler, this);
			}

			// Since loading may take some time, wire up a listener to fire when at least the first
			// element actually gets loaded
			var visibleExtent = this._calculateVisibleExtent();
			YAHOO.util.Event.onAvailable(this._carouselElemID + "-item-" +
					visibleExtent.start, this._calculateSize, this);

			// Call the initial loading sequence
			if (this.cfg.getProperty("loadOnStart"))
				this._loadInitial();

		},

		// /////////////////// Public API //////////////////////////////////////////

		/**
		* Clears all items from the list and resets to the carousel to its original initial state.
		*/
		clear: function () {
			// remove all items from the carousel for dynamic content
			var loadInitHandler = this.cfg.getProperty("loadInitHandler");
			if (loadInitHandler) {
				this._removeChildrenFromNode(this.carouselList);
				this._lastPrebuiltIdx = 0;
			}
			// turn off autoplay
			this.stopAutoPlay(); // should we only turn this off for dynamic during reload?

			this._priorLastVisible = this._priorFirstVisible = this._origFirstVisible;

			// is this redundant since moveTo will set this?	
			this.cfg.setProperty("firstVisible", this._origFirstVisible, true);
			this.moveTo(this._origFirstVisible);
		},

		/**
		* Clears all items from the list and calls the loadInitHandler to load new items into the list. 
		* The carousel size is reset to the original size set during creation.
		* @param {number}	numVisible	Optional parameter: numVisible. 
		* If set, the carousel will resize on the reload to show numVisible items.
		*/
		reload: function (numVisible) {
			// this should be deprecated, not needed since can be set via property change
			if (this._isValidObj(numVisible)) {
				this.cfg.setProperty("numVisible", numVisible);
			}
			this.clear();

			// clear resets back to start
			var visibleExtent = this._calculateVisibleExtent();
			YAHOO.util.Event.onAvailable(this._carouselElemID + "-item-" + visibleExtent.start,
		 								this._calculateSize, this);
			this._loadInitial();

		},

		load: function () {
			var visibleExtent = this._calculateVisibleExtent();

			YAHOO.util.Event.onAvailable(this._carouselElemID + "-item-" + visibleExtent.start,
						this._calculateSize, this);
			this._loadInitial();
		},

		/**
		* With patch from Dan Hobbs for handling unordered loading.
		* @param {number}	idx	which item in the list to potentially create. 
		* If item already exists it will not create a new item.
		* @param {string}	innerHTML	The innerHTML string to use to create the contents of an LI element.
		* @param {string}	itemClass	A class optionally supplied to add to the LI item created
		*/
		addItem: function (idx, innerHTMLOrElem, itemClass) {

			if (idx > this.cfg.getProperty("size")) {
				return null;
			}

			var liElem = this.getItem(idx);

			// Need to create the li
			if (!this._isValidObj(liElem)) {
				liElem = this._createItem(idx, innerHTMLOrElem);
				this.carouselList.appendChild(liElem);

			} else if (this._isValidObj(liElem.placeholder)) {
				var newLiElem = this._createItem(idx, innerHTMLOrElem);
				this.carouselList.replaceChild(newLiElem, liElem);
				liElem = newLiElem;
			}

			// if they supplied an item class add it to the element
			if (this._isValidObj(itemClass)) {
				YAHOO.util.Dom.addClass(liElem, itemClass);
			}

			/**
			* Not real comfortable with this line of code. It exists for vertical
			* carousels for IE6. For some reason LI elements are not displaying
			* unless you after the fact set the display to block. (Even though
			* the CSS sets vertical LIs to display:block)
			*/
			if (this.isVertical())
				setTimeout(function () { liElem.style.display = "block"; }, 1);

			return liElem;

		},

		/**
		* Inserts a new LI item before the index specified. Uses the innerHTML to create the contents of the new LI item
		* @param {number}	refIdx	which item in the list to insert this item before. 
		* @param {string}	innerHTML	The innerHTML string to use to create the contents of an LI element.
		*/
		insertBefore: function (refIdx, innerHTML) {
			// don't allow insertion beyond the size
			if (refIdx >= this.cfg.getProperty("size")) {
				return null;
			}

			if (refIdx < 1) {
				refIdx = 1;
			}

			var insertionIdx = refIdx - 1;

			if (insertionIdx > this._lastPrebuiltIdx) {
				this._prebuildItems(this._lastPrebuiltIdx, refIdx); // is this right?
			}

			var liElem = this._insertBeforeItem(refIdx, innerHTML);

			this._enableDisableControls();

			return liElem;
		},

		/**
		* Inserts a new LI item after the index specified. Uses the innerHTML to create the contents of the new LI item
		* @param {number}	refIdx	which item in the list to insert this item after. 
		* @param {string}	innerHTML	The innerHTML string to use to create the contents of an LI element.
		*/
		insertAfter: function (refIdx, innerHTML) {

			if (refIdx > this.cfg.getProperty("size")) {
				refIdx = this.cfg.getProperty("size");
			}

			var insertionIdx = refIdx + 1;

			// if we are inserting this item past where we have prebuilt items, then
			// prebuild up to this point.
			if (insertionIdx > this._lastPrebuiltIdx) {
				this._prebuildItems(this._lastPrebuiltIdx, insertionIdx + 1);
			}

			var liElem = this._insertAfterItem(refIdx, innerHTML);

			if (insertionIdx > this.cfg.getProperty("size")) {
				this.cfg.setProperty("size", insertionIdx, true);
			}

			this._enableDisableControls();

			return liElem;
		},

		/**
		* Simulates a next button event. Causes the carousel to scroll the next set of content into view.
		*/
		scrollNext: function () {
			this._scrollNext(null, this);

			// we know the timer has expired.
			//if(this._autoPlayTimer) clearTimeout(this._autoPlayTimer);
			this._autoPlayTimer = null;
			if (this.cfg.getProperty("autoPlay") !== 0) {
				this._autoPlayTimer = this.startAutoPlay();
			}
		},

		/**
		* Simulates a prev button event. Causes the carousel to scroll the previous set of content into view.
		*/
		scrollPrev: function () {
			this._scrollPrev(null, this);
		},

		/**
		* Scrolls the content to place itemNum as the start item in the view 
		* (if size is specified, the last element will not scroll past the end.). 
		* Uses current animation speed & method.
		* @param {number}	newStart	The item to scroll to. 
		*/
		scrollTo: function (newStart) {
			this._position(newStart, true);
		},

		/**
		* Moves the content to place itemNum as the start item in the view 
		* (if size is specified, the last element will not scroll past the end.) 
		* Ignores animation speed & method; moves directly to the item. 
		* Note that you can also set the <em>firstVisible</em> property upon initialization 
		* to get the carousel to start at a position different than 1.	
		* @param {number}	newStart	The item to move directly to. 
		*/
		moveTo: function (newStart) {
			this._position(newStart, false);
		},

		/**
		* Starts up autoplay. If autoPlay has been stopped (by calling stopAutoPlay or by user interaction), 
		* you can start it back up by using this method.
		* @param {number}	interval	optional parameter that sets the interval 
		* for auto play the next time that autoplay fires. 
		*/
		startAutoPlay: function (interval) {
			// if interval is passed as arg, then set autoPlay to this interval.
			if (this._isValidObj(interval)) {
				this.cfg.setProperty("autoPlay", interval, true);
			}

			// if we already are playing, then do nothing.
			if (this._autoPlayTimer !== null) {
				return this._autoPlayTimer;
			}

			var oThis = this;
			var autoScroll = function () { oThis.scrollNext(); };
			this._autoPlayTimer = setTimeout(autoScroll, this.cfg.getProperty("autoPlay"));

			return this._autoPlayTimer;
		},

		/**
		* Stops autoplay. Useful for when you want to control what events will stop the autoplay feature. 
		* Call <em>startAutoPlay()</em> to restart autoplay.
		*/
		stopAutoPlay: function () {
			if (this._autoPlayTimer !== null) {
				clearTimeout(this._autoPlayTimer);
				this._autoPlayTimer = null;
			}
		},

		/**
		* Returns whether the carousel's orientation is set to vertical.
		*/
		isVertical: function () {
			return (this.cfg.getProperty("orientation") != "horizontal");
		},


		/**
		* Check to see if an element (by index) has been loaded or not. If the item is simply pre-built, but not
		* loaded this will return false. If the item has not been pre-built it will also return false.
		* @param {number}	idx	Index of the element to check load status for. 
		*/
		isItemLoaded: function (idx) {
			var liElem = this.getItem(idx);

			// if item exists and is not a placeholder, then it is already loaded.
			if (this._isValidObj(liElem) && !this._isValidObj(liElem.placeholder)) {
				return true;
			}

			return false;
		},

		/**
		* Lookup the element object for a carousel list item by index.
		* @param {number}	idx	Index of the element to lookup. 
		*/
		getItem: function (idx) {
			var elemName = this._carouselElemID + "-item-" + idx;
			var liElem = YAHOO.util.Dom.get(elemName);
			return liElem;
		},

		show: function () {
			YAHOO.util.Dom.setStyle(this.carouselElem, "display", "block");
			this.calculateSize();
		},

		hide: function () {
			YAHOO.util.Dom.setStyle(this.carouselElem, "display", "none");
		},

		calculateSize: function () {
			var ulKids = this.carouselList.childNodes;
			var li = null;
			for (var i = 0; i < ulKids.length; i++) {

				li = ulKids[i];
				if (li.tagName == "LI" || li.tagName == "li") {
					break;
				}
			}

			var navMargin = this.cfg.getProperty("navMargin");
			var numVisible = this.cfg.getProperty("numVisible");
			var firstVisible = this.cfg.getProperty("firstVisible");
			var pl = this._getStyleVal(li, "paddingLeft");
			var pr = this._getStyleVal(li, "paddingRight");
			var ml = this._getStyleVal(li, "marginLeft");
			var mr = this._getStyleVal(li, "marginRight");
			var pt = this._getStyleVal(li, "paddingTop");
			var pb = this._getStyleVal(li, "paddingBottom");
			var mt = this._getStyleVal(li, "marginTop");
			var mb = this._getStyleVal(li, "marginBottom");

			YAHOO.util.Dom.removeClass(this.carouselList, "carousel-vertical");
			YAHOO.util.Dom.removeClass(this.carouselList, "carousel-horizontal");
			if (this.isVertical()) {
				var liPaddingMarginWidth = pl + pr + ml + mr;
				YAHOO.util.Dom.addClass(this.carouselList, "carousel-vertical");
				var liPaddingMarginHeight = pt + pb + mt + mb;

				var upt = this._getStyleVal(this.carouselList, "paddingTop");
				var upb = this._getStyleVal(this.carouselList, "paddingBottom");
				var umt = this._getStyleVal(this.carouselList, "marginTop");
				var umb = this._getStyleVal(this.carouselList, "marginBottom");
				var ulPaddingHeight = upt + upb + umt + umb;

				// try to reveal the amount taking into consideration the margin & padding.
				// This guarantees that this.revealAmount of pixels will be shown on both sides
				var revealAmt = (this._isExtraRevealed()) ?
			 			(this.cfg.getProperty("revealAmount") + (liPaddingMarginHeight) / 2) : 0;

				// get the height from the height computed style not the offset height
				// The reason is that on IE the offsetHeight when some part of the margin is
				// explicitly set to 'auto' can cause accessing that value to crash AND
				// on FF, in certain cases the actual value used for the LI's height is fractional
				// For example, while li.offsetHeight might return 93, YAHOO.util.Dom.getStyle(li, "height") 
				// would return "93.2px". This fractional value will affect the scrolling, so it must be
				// factored in for FF.
				// The caveat is that for IE, you will need to set the LI's height explicitly
				// REPLACED: this.scrollAmountPerInc = (li.offsetHeight + liPaddingMarginHeight);
				// WITH:
				var liHeight = this._getStyleVal(li, "height", true);
				this.scrollAmountPerInc = (liHeight + liPaddingMarginHeight);

				var liWidth = this._getStyleVal(li, "width");
				this.carouselElem.style.width = (liWidth + liPaddingMarginWidth) + "px";
				this._clipReg.style.height =
					(this.scrollAmountPerInc * numVisible + revealAmt * 2 +
					ulPaddingHeight) + "px";

				this.carouselElem.style.height =
				(this.scrollAmountPerInc * numVisible + revealAmt * 2 + navMargin * 2 +
					ulPaddingHeight) + "px";

				// possible that the umt+upt is needed... need to test this.
				var revealTop = (this._isExtraRevealed()) ? (revealAmt - (Math.abs(mt - mb) + Math.abs(pt - pb)) / 2) : 0;
				YAHOO.util.Dom.setStyle(this.carouselList, "position", "relative");
				YAHOO.util.Dom.setStyle(this.carouselList, "top", "" + revealTop + "px");

				// if we set the initial start > 1 then this will adjust the scrolled location
				var currY = YAHOO.util.Dom.getY(this.carouselList);
				YAHOO.util.Dom.setY(this.carouselList, currY - this.scrollAmountPerInc * (firstVisible - 1));

				// --- HORIZONTAL
			} else {
				YAHOO.util.Dom.addClass(this.carouselList, "carousel-horizontal");

				var upl = this._getStyleVal(this.carouselList, "paddingLeft");
				var upr = this._getStyleVal(this.carouselList, "paddingRight");
				var uml = this._getStyleVal(this.carouselList, "marginLeft");
				var umr = this._getStyleVal(this.carouselList, "marginRight");
				// If value of umr is less-than zero
				if (umr < 0) {
					umr = 0;
				}

				var ulPaddingWidth = upl + upr + uml + umr;

				var liMarginWidth = ml + mr;
				var liPaddingMarginWidth1 = liMarginWidth + pr + pl;

				// try to reveal the amount taking into consideration the margin & padding.
				// This guarantees that this.revealAmount of pixels will be shown on both sides
				var revealAmt1 = (this._isExtraRevealed()) ? (this.cfg.getProperty("revealAmount") + (liPaddingMarginWidth1) / 2) : 0;

				var liWidth1 = li.offsetWidth;
				this.scrollAmountPerInc = liWidth1 + liMarginWidth;

				this._clipReg.style.width =
					(this.scrollAmountPerInc * numVisible + revealAmt1 * 2) + "px";
				this.carouselElem.style.width =
			 		(this.scrollAmountPerInc * numVisible + navMargin * 2 + revealAmt1 * 2 +
					ulPaddingWidth) + "px";

				var revealLeft = (this._isExtraRevealed()) ? (revealAmt1 - (Math.abs(mr - ml) + Math.abs(pr - pl)) / 2 - (uml + upl)) : 0;
				YAHOO.util.Dom.setStyle(this.carouselList, "position", "relative");
				YAHOO.util.Dom.setStyle(this.carouselList, "left", "" + revealLeft + "px");

				// if we set the initial start > 1 then this will adjust the scrolled location
				var currX = YAHOO.util.Dom.getX(this.carouselList);
				YAHOO.util.Dom.setX(this.carouselList, currX - this.scrollAmountPerInc * (firstVisible - 1));
			}
		},

		// Hides the cfg object
		setProperty: function (property, value, silent) {
			this.cfg.setProperty(property, value, silent);
		},

		getProperty: function (property) {
			return this.cfg.getProperty(property);
		},

		getFirstItemRevealed: function () {
			return this._firstItemRevealed;
		},
		getLastItemRevealed: function () {
			return this._lastItemRevealed;
		},

		// Just for convenience and to be symmetrical with getFirstVisible
		getFirstVisible: function () {
			return this.cfg.getProperty("firstVisible");
		},

		getLastVisible: function () {
			var firstVisible = this.cfg.getProperty("firstVisible");
			var numVisible = this.cfg.getProperty("numVisible");

			return firstVisible + numVisible - 1;
		},

		// /////////////////// PRIVATE API //////////////////////////////////////////
		_getStyleVal: function (li, style, returnFloat) {
			var styleValStr = YAHOO.util.Dom.getStyle(li, style);

			var styleVal = returnFloat ? parseFloat(styleValStr) : parseInt(styleValStr, 10);
			if (style == "height" && isNaN(styleVal)) {
				styleVal = li.offsetHeight;
			} else if (isNaN(styleVal)) {
				styleVal = 0;
			}
			return styleVal;
		},

		_calculateSize: function (me) {
			me.calculateSize();
			me.show();
			//YAHOO.util.Dom.setStyle(me.carouselElem, "visibility", "visible");
		},

		// From Mike Chambers: http://weblogs.macromedia.com/mesh/archives/2006/01/removing_html_e.html
		_removeChildrenFromNode: function (node) {
			if (!this._isValidObj(node)) {
				return;
			}

			var len = node.childNodes.length;

			while (node.hasChildNodes()) {
				node.removeChild(node.firstChild);
			}
		},

		_prebuildLiElem: function (idx) {
			if (idx < 1) return;


			var liElem = document.createElement("li");
			liElem.id = this._carouselElemID + "-item-" + idx;
			// this is default flag to know that we're not really loaded yet.
			liElem.placeholder = true;
			this.carouselList.appendChild(liElem);

			this._lastPrebuiltIdx = (idx > this._lastPrebuiltIdx) ? idx : this._lastPrebuiltIdx;
		},

		_createItem: function (idx, innerHTMLOrElem) {
			if (idx < 1) {
				return null;
			}


			var liElem = document.createElement("li");
			liElem.id = this._carouselElemID + "-item-" + idx;

			// if String then assume innerHTML, else an elem object
			if (typeof (innerHTMLOrElem) === "string") {
				liElem.innerHTML = innerHTMLOrElem;
			} else {
				liElem.appendChild(innerHTMLOrElem);
			}

			return liElem;
		},

		// idx is the location to insert after
		_insertAfterItem: function (refIdx, innerHTMLOrElem) {
			return this._insertBeforeItem(refIdx + 1, innerHTMLOrElem);
		},


		_insertBeforeItem: function (refIdx, innerHTMLOrElem) {

			var refItem = this.getItem(refIdx);
			var size = this.cfg.getProperty("size");
			if (size != this.UNBOUNDED_SIZE) {
				this.cfg.setProperty("size", size + 1, true);
			}

			for (var i = this._lastPrebuiltIdx; i >= refIdx; i--) {
				var anItem = this.getItem(i);
				if (this._isValidObj(anItem)) {
					anItem.id = this._carouselElemID + "-item-" + (i + 1);
				}
			}

			var liElem = this._createItem(refIdx, innerHTMLOrElem);

			var insertedItem = this.carouselList.insertBefore(liElem, refItem);
			this._lastPrebuiltIdx += 1;

			return liElem;
		},

		// TEST THIS... think it has to do with prebuild
		insertAfterEnd: function (innerHTMLOrElem) {
			return this.insertAfter(this.cfg.getProperty("size"), innerHTMLOrElem);
		},

		_position: function (newStart, showAnimation) {
			// do we bypass the isAnimated check?
			var currStart = this._priorFirstVisible;
			if (newStart > currStart) {
				var inc = newStart - currStart;
				this._scrollNextInc(inc, showAnimation);
			} else {
				var dec = currStart - newStart;
				this._scrollPrevInc(dec, showAnimation);
			}
		},

		_scrollPrev: function (e, carousel) {
			if (e !== null) { // event fired this so disable autoplay
				carousel.stopAutoPlay();
			}
			if (carousel._scrollPrevAnim.isAnimated()) {
				return false;
			}
			carousel._scrollPrevInc(carousel.cfg.getProperty("scrollInc"),
							(carousel.cfg.getProperty("animationSpeed") !== 0));
			return true;
		},

		// event handler
		_scrollNext: function (e, carousel) {
			if (e !== null) { // event fired this so disable autoplay
				carousel.stopAutoPlay();
			}
			if (carousel._scrollNextAnim.isAnimated()) {
				return false; // might be better to set ourself waiting for animation completion and
				// then just do this function. that will allow faster scroll responses.
			}

			carousel._scrollNextInc(carousel.cfg.getProperty("scrollInc"),
								(carousel.cfg.getProperty("animationSpeed") !== 0));
			return true;
		},


		_handleAnimationComplete: function (type, args, argList) {
			var carousel = argList[0];
			var direction = argList[1];

			carousel._animationCompleteEvt.fire(direction);


		},

		// If EVERY item is already loaded in the range then return true
		// Also prebuild whatever is not already created.
		_areAllItemsLoaded: function (first, last) {
			var itemsLoaded = true;
			for (var i = first; i <= last; i++) {
				var liElem = this.getItem(i);

				// If the li elem does not exist, then prebuild it in the correct order
				// but still flag as not loaded (just prebuilt the li item.
				if (!this._isValidObj(liElem)) {
					this._prebuildLiElem(i);
					itemsLoaded = false;
					// but if the item exists and is a placeholder, then
					// note that this item is not loaded (only a placeholder)
				} else if (this._isValidObj(liElem.placeholder)) {
					itemsLoaded = false;
				}
			}
			return itemsLoaded;
		},

		_prebuildItems: function (first, last) {
			for (var i = first; i <= last; i++) {
				var liElem = this.getItem(i);

				// If the li elem does not exist, then prebuild it in the correct order
				// but still flag as not loaded (just prebuilt the li item.
				if (!this._isValidObj(liElem)) {
					this._prebuildLiElem(i);
				}
			}
		},

		_isExtraRevealed: function () {
			return (this.cfg.getProperty("revealAmount") > 0);
		},

		// probably no longer need carousel passed in, this should be correct now.
		_scrollNextInc: function (inc, showAnimation) {
			var numVisible = this.cfg.getProperty("numVisible");
			var currStart = this._priorFirstVisible;
			var currEnd = this._priorLastVisible;
			var size = this.cfg.getProperty("size");

			var scrollExtent = this._calculateAllowableScrollExtent();

			if (this.cfg.getProperty("wrap") && currEnd == scrollExtent.end) {
				this.scrollTo(scrollExtent.start); // might need to check animation is on or not
				return false;
			}

			// increment start by inc
			var newStart = currStart + inc;
			var newEnd = newStart + numVisible - 1;

			// If we are past the end, adjust or wrap
			if (newEnd > scrollExtent.end) {
				newEnd = scrollExtent.end;
				newStart = newEnd - numVisible + 1;
			}

			inc = newStart - currStart;

			// at this point the following variables are set
			// inc... amount to increment by
			// newStart... the firstVisible item after the scroll
			// newEnd... the last item visible after the scroll

			this.cfg.setProperty("firstVisible", newStart, true);


			if (inc > 0) {
				if (this._isValidObj(this.cfg.getProperty("loadNextHandler"))) {
					var visibleExtent = this._calculateVisibleExtent(newStart, newEnd);
					var cacheStart = (currEnd + 1) < visibleExtent.start ? (currEnd + 1) : visibleExtent.start;
					var alreadyCached = this._areAllItemsLoaded(cacheStart, visibleExtent.end);
					this._loadNextHandlerEvt.fire(visibleExtent.start, visibleExtent.end, alreadyCached);
				}

				if (showAnimation) {
					var nextParams = { points: { by: [-this.scrollAmountPerInc * inc, 0]} };
					if (this.isVertical()) {
						nextParams = { points: { by: [0, -this.scrollAmountPerInc * inc]} };
					}

					this._scrollNextAnim = new YAHOO.util.Motion(this.carouselList,
	 							nextParams,
   								this.cfg.getProperty("animationSpeed"),
								this.cfg.getProperty("animationMethod"));

					// is this getting added multiple times?
					if (this.cfg.getProperty("animationCompleteHandler")) {
						this._scrollNextAnim.onComplete.subscribe(this._handleAnimationComplete, [this, "next"]);
					}
					this._scrollNextAnim.animate();
				} else {
					if (this.isVertical()) {
						var currY = YAHOO.util.Dom.getY(this.carouselList);

						YAHOO.util.Dom.setY(this.carouselList,
								currY - this.scrollAmountPerInc * inc);
					} else {
						var currX = YAHOO.util.Dom.getX(this.carouselList);
						YAHOO.util.Dom.setX(this.carouselList,
								currX - this.scrollAmountPerInc * inc);
					}
				}

			}
			this._priorFirstVisible = newStart;
			this._priorLastVisible = newEnd;

			this._enableDisableControls();
			return false;
		},

		// firstVisible is already set
		_scrollPrevInc: function (dec, showAnimation) {
			var numVisible = this.cfg.getProperty("numVisible");
			var currStart = this._priorFirstVisible;
			var currEnd = this._priorLastVisible;
			var size = this.cfg.getProperty("size");

			// decrement start by dec
			var newStart = currStart - dec;

			var scrollExtent = this._calculateAllowableScrollExtent();

			// How to decide whether to stop at 1 or not
			newStart = (newStart < scrollExtent.start) ? scrollExtent.start : newStart;

			// if we are going to extend past the end, then we need to correct the start
			var newEnd = newStart + numVisible - 1;
			if (newEnd > scrollExtent.end) {
				newEnd = scrollExtent.end;
				newStart = newEnd - numVisible + 1;
			}

			dec = currStart - newStart;

			// at this point the following variables are set
			// dec... amount to decrement by
			// newStart... the firstVisible item after the scroll
			// newEnd... the last item visible after the scroll
			this.cfg.setProperty("firstVisible", newStart, true);

			// if we are decrementing
			if (dec > 0) {
				if (this._isValidObj(this.cfg.getProperty("loadPrevHandler"))) {
					var visibleExtent = this._calculateVisibleExtent(newStart, newEnd);
					var cacheEnd = (currStart - 1) > visibleExtent.end ? (currStart - 1) : visibleExtent.end;
					var alreadyCached = this._areAllItemsLoaded(visibleExtent.start, cacheEnd);

					this._loadPrevHandlerEvt.fire(visibleExtent.start, visibleExtent.end, alreadyCached);
				}

				if (showAnimation) {
					var prevParams = { points: { by: [this.scrollAmountPerInc * dec, 0]} };
					if (this.isVertical()) {
						prevParams = { points: { by: [0, this.scrollAmountPerInc * dec]} };
					}

					this._scrollPrevAnim = new YAHOO.util.Motion(this.carouselList,
	 							prevParams,
   								this.cfg.getProperty("animationSpeed"), this.cfg.getProperty("animationMethod"));
					if (this.cfg.getProperty("animationCompleteHandler")) {
						this._scrollPrevAnim.onComplete.subscribe(this._handleAnimationComplete, [this, "prev"]);
					}
					this._scrollPrevAnim.animate();
				} else {
					if (this.isVertical()) {
						var currY = YAHOO.util.Dom.getY(this.carouselList);
						YAHOO.util.Dom.setY(this.carouselList, currY +
							this.scrollAmountPerInc * dec);
					} else {
						var currX = YAHOO.util.Dom.getX(this.carouselList);
						YAHOO.util.Dom.setX(this.carouselList, currX +
							this.scrollAmountPerInc * dec);
					}
				}
			}
			this._priorFirstVisible = newStart;
			this._priorLastVisible = newEnd;

			this._enableDisableControls();

			return false;
		},

		// Check for all cases and enable/disable controls as needed by current state
		_enableDisableControls: function () {

			var firstVisible = this.cfg.getProperty("firstVisible");
			var lastVisible = this.getLastVisible();
			var scrollExtent = this._calculateAllowableScrollExtent();

			// previous arrow is turned on. Check to see if we need to turn it off
			if (this._prevEnabled) {
				if (firstVisible === scrollExtent.start) {
					this._disablePrev();
				}
			}

			// previous arrow is turned off. Check to see if we need to turn it on
			if (this._prevEnabled === false) {
				if (firstVisible > scrollExtent.start) {
					this._enablePrev();
				}
			}

			// next arrow is turned on. Check to see if we need to turn it off
			if (this._nextEnabled) {
				if (lastVisible === scrollExtent.end) {
					this._disableNext();
				}
			}

			// next arrow is turned off. Check to see if we need to turn it on
			if (this._nextEnabled === false) {
				if (lastVisible < scrollExtent.end) {
					this._enableNext();
				}
			}
		},

		/**
		* _loadInitial looks at firstItemVisible for the start (not necessarily 1)
		*/
		_loadInitial: function () {
			var firstVisible = this.cfg.getProperty("firstVisible");
			this._priorLastVisible = this.getLastVisible();
			// Load from 1 to the last visible
			// The _calculateSize method will adjust the scroll position
			// for starts > 1
			if (this._loadInitHandlerEvt) {
				var visibleExtent = this._calculateVisibleExtent(firstVisible, this._priorLastVisible);
				// still treat the first real item as starting at 1 
				var alreadyCached = this._areAllItemsLoaded(1, visibleExtent.end);

				this._loadInitHandlerEvt.fire(visibleExtent.start, visibleExtent.end, alreadyCached);
			}

			if (this.cfg.getProperty("autoPlay") !== 0) {
				this._autoPlayTimer = this.startAutoPlay();
			}

			this._enableDisableControls();
		},

		_calculateAllowableScrollExtent: function () {
			var scrollBeforeAmount = this.cfg.getProperty("scrollBeforeAmount");
			var scrollAfterAmount = this.cfg.getProperty("scrollAfterAmount");
			var size = this.cfg.getProperty("size");

			var extent = { start: 1 - scrollBeforeAmount, end: size + scrollAfterAmount };
			return extent;

		},

		_calculateVisibleExtent: function (start, end) {
			if (!start) {
				start = this.cfg.getProperty("firstVisible");
				end = this.getLastVisible();
			}

			var size = this.cfg.getProperty("size");

			// we ignore the firstItem property... this method is used
			// for prebuilding the cache and signaling the developer
			// what to render on a given scroll.
			start = start < 1 ? 1 : start;
			end = end > size ? size : end;

			var extent = { start: start, end: end };

			// set up the indices for revealed items. If there is no item revealed, then set
			// the index to -1
			this._firstItemRevealed = -1;
			this._lastItemRevealed = -1;
			if (this._isExtraRevealed()) {
				if (start > 1) {
					this._firstItemRevealed = start - 1;
					extent.start = this._firstItemRevealed;
				}
				if (end < size) {
					this._lastItemRevealed = end + 1;
					extent.end = this._lastItemRevealed;
				}
			}

			return extent;
		},

		_disablePrev: function () {
			this._prevEnabled = false;
			if (this._prevButtonStateHandlerEvt) {
				this._prevButtonStateHandlerEvt.fire(false, this._carouselPrev);
			}
			if (this._isValidObj(this._carouselPrev)) {
				YAHOO.util.Event.removeListener(this._carouselPrev, "click", this._scrollPrev);
			}
		},

		_enablePrev: function () {
			this._prevEnabled = true;
			if (this._prevButtonStateHandlerEvt) {
				this._prevButtonStateHandlerEvt.fire(true, this._carouselPrev);
			}
			if (this._isValidObj(this._carouselPrev)) {
				YAHOO.util.Event.addListener(this._carouselPrev, "click", this._scrollPrev, this);
			}
		},

		_disableNext: function () {
			if (this.cfg.getProperty("wrap")) {
				return;
			}
			this._nextEnabled = false;
			if (this._isValidObj(this._nextButtonStateHandlerEvt)) {
				this._nextButtonStateHandlerEvt.fire(false, this._carouselNext);
			}
			if (this._isValidObj(this._carouselNext)) {
				YAHOO.util.Event.removeListener(this._carouselNext, "click", this._scrollNext);
			}
		},

		_enableNext: function () {
			this._nextEnabled = true;
			if (this._isValidObj(this._nextButtonStateHandlerEvt)) {
				this._nextButtonStateHandlerEvt.fire(true, this._carouselNext);
			}
			if (this._isValidObj(this._carouselNext)) {
				YAHOO.util.Event.addListener(this._carouselNext, "click", this._scrollNext, this);
			}
		},

		_isValidObj: function (obj) {

			if (null == obj) {
				return false;
			}
			if ("undefined" == typeof (obj)) {
				return false;
			}
			return true;
		}
	};
var $NS = YAHOO.namespace('pops');

// Global Variables for Carousel
// these names used in other js files so don't change
var photosCarousel;	
var photoTreesCarousel;

// What's New - photo carousel
function whatsNewSetup (username, ancestryDomain, treesDomain, pageStack, cache, isReadonly)
{
	// this TreesCarousel has extended data for the Trees version of the Carousel
	photoTreesCarousel = new TreesCarousel(
			{
				"ajaxHandler":		"getwhatsnew.ashx",
				"treeId":			v_treeId,
				"personId":			v_personId,
				"userId":			v_uid,
				"userName":			username,
				"ancestryDomain":	ancestryDomain,
				"treesDomain":		treesDomain,
				"currPgArgs":		pageStack,
				"rightArrow":			v_treesCacheUrl + "legacy/i/view/military/right_arrow.gif",
				"rightArrowDisabled":	v_treesCacheUrl + "legacy/i/view/military/right_arrow_disabled.gif",
				"leftArrow":			v_treesCacheUrl + "legacy/i/view/military/left_arrow.gif",
				"leftArrowDisabled":	v_treesCacheUrl + "legacy/i/view/military/left_arrow_disabled.gif",
				"showTitle":		false,
				"addPhotoImg":		v_treesCacheUrl + "legacy/i/view/military/add_photo.jpg",
				"addPhotoUrl":		v_addPhotoUrl,
				"viewId":			v_viewId,
				"isReadonly":		isReadonly == "True" ? true : false,
				"totalCount":		v_photoCount
			}
			);
	photosCarousel = new YAHOO.extension.Carousel("photo-carousel", 
			{
				"numVisible":       3,
				"scrollInc":        3,
				"animationSpeed":   0.75,
				"animationMethod":  YAHOO.util.Easing.easeBoth,
				"navMargin":        20,
				"prevElement":		"prev-arrow-photo",
				"nextElement":		"next-arrow-photo",
				"loadInitHandler":	loadInitialPhotosAjax,
				"loadNextHandler":	loadNextPhotosAjax,
				"loadPrevHandler":	loadPrevPhotosAjax,
				"prevButtonStateHandler":	handlePrevPhotosButtonState,
				"nextButtonStateHandler":	handleNextPhotosButtonState
			}
			);
}

function audioAdded()
{
	window.location = window.location.href + "&msg=na";
}

function confirmRemove()
{
	return confirm(v_confirmRemove);
}
// jsr_class.js
//
// JSONscriptRequest -- a simple class for making HTTP requests
// using dynamically generated script tags and JSON
//
// Author: Jason Levitt
// Date: December 7th, 2005
//
// A SECURITY WARNING FROM DOUGLAS CROCKFORD:
// "The dynamic <script> tag hack suffers from a problem. It allows a page 
// to access data from any server in the web, which is really useful. 
// Unfortunately, the data is returned in the form of a script. That script 
// can deliver the data, but it runs with the same authority as scripts on 
// the base page, so it is able to steal cookies or misuse the authorization 
// of the user with the server. A rogue script can do destructive things to 
// the relationship between the user and the base server."
//
// So, be extremely cautious in your use of this script.
//
//
// Sample Usage:
//
// <script type="text/javascript" src="jsr_class.js"></script>
// 
// function callbackfunc(jsonData) {
//      alert('Latitude = ' + jsonData.ResultSet.Result[0].Latitude + 
//            '  Longitude = ' + jsonData.ResultSet.Result[0].Longitude);
//      aObj.removeScriptTag();
// }
//
// request = 'http://api.local.yahoo.com/MapsService/V1/geocode?appid=YahooDemo&
//            output=json&callback=callbackfunc&location=78704';
// aObj = new JSONscriptRequest(request);
// aObj.buildScriptTag();
// aObj.addScriptTag();
//
//


// Constructor -- pass a REST request URL to the constructor
//
function JSONscriptRequest(fullUrl) {
    // REST request path
    this.fullUrl = fullUrl;
    // Keep IE from caching requests
    this.noCacheIE = '&noCacheIE=' + (new Date()).getTime();
    // Get the DOM location to put the script tag
    this.headLoc = document.getElementsByTagName("head").item(0);
    // Generate a unique script tag id
    this.scriptId = 'JscriptId' + this.scriptCounter();
}

// Static script ID counter
JSONscriptRequest.prototype.scriptCounter = function () {
    return Math.round((Math.random() * 1000000) + 1);
}

// buildScriptTag method
//
JSONscriptRequest.prototype.buildScriptTag = function () {

    // Create the script tag
    this.scriptObj = document.createElement("script");

    // Add script object attributes
    this.scriptObj.setAttribute("type", "text/javascript");
    this.scriptObj.setAttribute("charset", "utf-8");
    this.scriptObj.setAttribute("src", this.fullUrl + this.noCacheIE);
    this.scriptObj.setAttribute("id", this.scriptId);
    this.scriptObj.setAttribute("defer", "defer");
}

// buildScriptTag method
//
JSONscriptRequest.prototype.buildScriptTagCss = function () {

    // Create the script tag
    this.scriptObj = document.createElement("link");
    // Add script object attributes
    this.scriptObj.setAttribute("type", "text/css");
    this.scriptObj.setAttribute("charset", "utf-8");
    this.scriptObj.setAttribute("href", this.fullUrl + this.noCacheIE);
    this.scriptObj.setAttribute("rel", "stylesheet");
    //this.scriptObj.setAttribute("id", this.scriptId);
    this.scriptObj.setAttribute("defer", "defer");
}

// removeScriptTag method
// 
JSONscriptRequest.prototype.removeScriptTag = function () {
    // Destroy the script tag
    this.headLoc.removeChild(this.scriptObj);
}

// addScriptTag method
//
JSONscriptRequest.prototype.addScriptTag = function () {
    // Create the script tag
    this.headLoc.appendChild(this.scriptObj);
}
/**
 * Copyright (c) 2006-2007, Bill W. Scott. All rights reserved.
 * This work is licensed under the Creative Commons Attribution 2.5 License. To view a copy 
 * of this license, visit http://creativecommons.org/licenses/by/2.5/ or send a letter to 
 * Creative Commons, 543 Howard Street, 5th Floor, San Francisco, California, 94105, USA.
 * This work was created by Bill Scott (billwscott.com, looksgoodworkswell.com).
 * The only attribution I require is to keep this notice of copyright & license 
 * in this original source file.
 * Version 0.6.1 - 07.08.2007
 */


YAHOO.namespace("extension"); YAHOO.extension.Carousel = function (carouselElementID, carouselCfg) { this.init(carouselElementID, carouselCfg); }; YAHOO.extension.Carousel.prototype = {
    UNBOUNDED_SIZE: 1000000, init: function (carouselElementID, carouselCfg) {
        var oThis = this; this.getCarouselItem = this.getItem; var carouselListClass = "carousel-list"; var carouselClipRegionClass = "carousel-clip-region"; var carouselNextClass = "carousel-next"; var carouselPrevClass = "carousel-prev"; this._carouselElemID = carouselElementID; this.carouselElem = YAHOO.util.Dom.get(carouselElementID); this._prevEnabled = true; this._nextEnabled = true; this.cfg = new YAHOO.util.Config(this); this.cfg.addProperty("scrollBeforeAmount", { value: 0, handler: function (type, args, carouselElem) { }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("scrollAfterAmount", { value: 0, handler: function (type, args, carouselElem) { }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("loadOnStart", { value: true, handler: function (type, args, carouselElem) { }, validator: oThis.cfg.checkBoolean }); this.cfg.addProperty("orientation", { value: "horizontal", handler: function (type, args, carouselElem) { oThis.reload(); }, validator: function (orientation) { if (typeof orientation == "string") { return ("horizontal,vertical".indexOf(orientation.toLowerCase()) != -1); } else { return false; } } }); this.cfg.addProperty("size", { value: this.UNBOUNDED_SIZE, handler: function (type, args, carouselElem) { oThis.reload(); }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("numVisible", { value: 3, handler: function (type, args, carouselElem) { oThis.reload(); }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("firstVisible", { value: 1, handler: function (type, args, carouselElem) { oThis.moveTo(args[0]); }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("scrollInc", { value: 3, handler: function (type, args, carouselElem) { }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("animationSpeed", { value: 0.25, handler: function (type, args, carouselElem) { oThis.animationSpeed = args[0]; }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("animationMethod", { value: YAHOO.util.Easing.easeOut, handler: function (type, args, carouselElem) { } }); this.cfg.addProperty("animationCompleteHandler", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._animationCompleteEvt) { oThis._animationCompleteEvt.unsubscribe(oThis._currAnimationCompleteHandler, oThis); }
                oThis._currAnimationCompleteHandler = args[0]; if (oThis._currAnimationCompleteHandler) {
                    if (!oThis._animationCompleteEvt) { oThis._animationCompleteEvt = new YAHOO.util.CustomEvent("onAnimationComplete", oThis); }
                    oThis._animationCompleteEvt.subscribe(oThis._currAnimationCompleteHandler, oThis);
                }
            }
        }); this.cfg.addProperty("autoPlay", {
            value: 0, handler: function (type, args, carouselElem) {
                var autoPlay = args[0]; if (autoPlay > 0)
                    oThis.startAutoPlay(); else
                    oThis.stopAutoPlay();
            }
        }); this.cfg.addProperty("wrap", { value: false, handler: function (type, args, carouselElem) { }, validator: oThis.cfg.checkBoolean }); this.cfg.addProperty("navMargin", { value: 0, handler: function (type, args, carouselElem) { oThis.calculateSize(); }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("revealAmount", { value: 0, handler: function (type, args, carouselElem) { oThis.reload(); }, validator: oThis.cfg.checkNumber }); this.cfg.addProperty("prevElementID", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._carouselPrev) { YAHOO.util.Event.removeListener(oThis._carouselPrev, "click", oThis._scrollPrev); }
                oThis._prevElementID = args[0]; if (oThis._prevElementID == null) { oThis._carouselPrev = YAHOO.util.Dom.getElementsByClassName(carouselPrevClass, "div", oThis.carouselElem)[0]; } else { oThis._carouselPrev = YAHOO.util.Dom.get(oThis._prevElementID); }
                YAHOO.util.Event.addListener(oThis._carouselPrev, "click", oThis._scrollPrev, oThis);
            }
        }); this.cfg.addProperty("prevElement", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._carouselPrev) { YAHOO.util.Event.removeListener(oThis._carouselPrev, "click", oThis._scrollPrev); }
                oThis._prevElementID = args[0]; if (oThis._prevElementID == null) { oThis._carouselPrev = YAHOO.util.Dom.getElementsByClassName(carouselPrevClass, "div", oThis.carouselElem)[0]; } else { oThis._carouselPrev = YAHOO.util.Dom.get(oThis._prevElementID); }
                YAHOO.util.Event.addListener(oThis._carouselPrev, "click", oThis._scrollPrev, oThis);
            }
        }); this.cfg.addProperty("nextElementID", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._carouselNext) { YAHOO.util.Event.removeListener(oThis._carouselNext, "click", oThis._scrollNext); }
                oThis._nextElementID = args[0]; if (oThis._nextElementID == null) { oThis._carouselNext = YAHOO.util.Dom.getElementsByClassName(carouselNextClass, "div", oThis.carouselElem); } else { oThis._carouselNext = YAHOO.util.Dom.get(oThis._nextElementID); }
                if (oThis._carouselNext) { YAHOO.util.Event.addListener(oThis._carouselNext, "click", oThis._scrollNext, oThis); }
            }
        }); this.cfg.addProperty("nextElement", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._carouselNext) { YAHOO.util.Event.removeListener(oThis._carouselNext, "click", oThis._scrollNext); }
                oThis._nextElementID = args[0]; if (oThis._nextElementID == null) { oThis._carouselNext = YAHOO.util.Dom.getElementsByClassName(carouselNextClass, "div", oThis.carouselElem); } else { oThis._carouselNext = YAHOO.util.Dom.get(oThis._nextElementID); }
                if (oThis._carouselNext) { YAHOO.util.Event.addListener(oThis._carouselNext, "click", oThis._scrollNext, oThis); }
            }
        }); this.cfg.addProperty("loadInitHandler", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._loadInitHandlerEvt) { oThis._loadInitHandlerEvt.unsubscribe(oThis._currLoadInitHandler, oThis); }
                oThis._currLoadInitHandler = args[0]; if (oThis._currLoadInitHandler) {
                    if (!oThis._loadInitHandlerEvt) { oThis._loadInitHandlerEvt = new YAHOO.util.CustomEvent("onLoadInit", oThis); }
                    oThis._loadInitHandlerEvt.subscribe(oThis._currLoadInitHandler, oThis);
                }
            }
        }); this.cfg.addProperty("loadNextHandler", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._loadNextHandlerEvt) { oThis._loadNextHandlerEvt.unsubscribe(oThis._currLoadNextHandler, oThis); }
                oThis._currLoadNextHandler = args[0]; if (oThis._currLoadNextHandler) {
                    if (!oThis._loadNextHandlerEvt) { oThis._loadNextHandlerEvt = new YAHOO.util.CustomEvent("onLoadNext", oThis); }
                    oThis._loadNextHandlerEvt.subscribe(oThis._currLoadNextHandler, oThis);
                }
            }
        }); this.cfg.addProperty("loadPrevHandler", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._loadPrevHandlerEvt) { oThis._loadPrevHandlerEvt.unsubscribe(oThis._currLoadPrevHandler, oThis); }
                oThis._currLoadPrevHandler = args[0]; if (oThis._currLoadPrevHandler) {
                    if (!oThis._loadPrevHandlerEvt) { oThis._loadPrevHandlerEvt = new YAHOO.util.CustomEvent("onLoadPrev", oThis); }
                    oThis._loadPrevHandlerEvt.subscribe(oThis._currLoadPrevHandler, oThis);
                }
            }
        }); this.cfg.addProperty("prevButtonStateHandler", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._currPrevButtonStateHandler) { oThis._prevButtonStateHandlerEvt.unsubscribe(oThis._currPrevButtonStateHandler, oThis); }
                oThis._currPrevButtonStateHandler = args[0]; if (oThis._currPrevButtonStateHandler) {
                    if (!oThis._prevButtonStateHandlerEvt) { oThis._prevButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onPrevButtonStateChange", oThis); }
                    oThis._prevButtonStateHandlerEvt.subscribe(oThis._currPrevButtonStateHandler, oThis);
                }
            }
        }); this.cfg.addProperty("nextButtonStateHandler", {
            value: null, handler: function (type, args, carouselElem) {
                if (oThis._currNextButtonStateHandler) { oThis._nextButtonStateHandlerEvt.unsubscribe(oThis._currNextButtonStateHandler, oThis); }
                oThis._currNextButtonStateHandler = args[0]; if (oThis._currNextButtonStateHandler) {
                    if (!oThis._nextButtonStateHandlerEvt) { oThis._nextButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onNextButtonStateChange", oThis); }
                    oThis._nextButtonStateHandlerEvt.subscribe(oThis._currNextButtonStateHandler, oThis);
                }
            }
        }); if (carouselCfg) { this.cfg.applyConfig(carouselCfg); }
        this._origFirstVisible = this.cfg.getProperty("firstVisible"); this._currLoadInitHandler = this.cfg.getProperty("loadInitHandler"); this._currLoadNextHandler = this.cfg.getProperty("loadNextHandler"); this._currLoadPrevHandler = this.cfg.getProperty("loadPrevHandler"); this._currPrevButtonStateHandler = this.cfg.getProperty("prevButtonStateHandler"); this._currNextButtonStateHandler = this.cfg.getProperty("nextButtonStateHandler"); this._currAnimationCompleteHandler = this.cfg.getProperty("animationCompleteHandler"); this._nextElementID = this.cfg.getProperty("nextElementID"); if (!this._nextElementID)
            this._nextElementID = this.cfg.getProperty("nextElement"); this._prevElementID = this.cfg.getProperty("prevElementID"); if (!this._prevElementID)
                this._prevElementID = this.cfg.getProperty("prevElement"); this._autoPlayTimer = null; this._priorLastVisible = this._priorFirstVisible = this.cfg.getProperty("firstVisible"); this._lastPrebuiltIdx = 0; this.carouselList = YAHOO.util.Dom.getElementsByClassName(carouselListClass, "ul", this.carouselElem)[0]; if (this._nextElementID == null) { this._carouselNext = YAHOO.util.Dom.getElementsByClassName(carouselNextClass, "div", this.carouselElem)[0]; } else { this._carouselNext = YAHOO.util.Dom.get(this._nextElementID); }
        if (this._prevElementID == null) { this._carouselPrev = YAHOO.util.Dom.getElementsByClassName(carouselPrevClass, "div", this.carouselElem)[0]; } else { this._carouselPrev = YAHOO.util.Dom.get(this._prevElementID); }
        this._clipReg = YAHOO.util.Dom.getElementsByClassName(carouselClipRegionClass, "div", this.carouselElem)[0]; if (this.isVertical()) { YAHOO.util.Dom.addClass(this.carouselList, "carousel-vertical"); }
        this._scrollNextAnim = new YAHOO.util.Motion(this.carouselList, this.scrollNextParams, this.cfg.getProperty("animationSpeed"), this.cfg.getProperty("animationMethod")); this._scrollPrevAnim = new YAHOO.util.Motion(this.carouselList, this.scrollPrevParams, this.cfg.getProperty("animationSpeed"), this.cfg.getProperty("animationMethod")); if (this._carouselNext) { YAHOO.util.Event.addListener(this._carouselNext, "click", this._scrollNext, this); }
        if (this._carouselPrev) { YAHOO.util.Event.addListener(this._carouselPrev, "click", this._scrollPrev, this); }
        var loadInitHandler = this.cfg.getProperty("loadInitHandler"); if (loadInitHandler) { this._loadInitHandlerEvt = new YAHOO.util.CustomEvent("onLoadInit", this); this._loadInitHandlerEvt.subscribe(loadInitHandler, this); }
        var loadNextHandler = this.cfg.getProperty("loadNextHandler"); if (loadNextHandler) { this._loadNextHandlerEvt = new YAHOO.util.CustomEvent("onLoadNext", this); this._loadNextHandlerEvt.subscribe(loadNextHandler, this); }
        var loadPrevHandler = this.cfg.getProperty("loadPrevHandler"); if (loadPrevHandler) { this._loadPrevHandlerEvt = new YAHOO.util.CustomEvent("onLoadPrev", this); this._loadPrevHandlerEvt.subscribe(loadPrevHandler, this); }
        var animationCompleteHandler = this.cfg.getProperty("animationCompleteHandler"); if (animationCompleteHandler) { this._animationCompleteEvt = new YAHOO.util.CustomEvent("onAnimationComplete", this); this._animationCompleteEvt.subscribe(animationCompleteHandler, this); }
        var prevButtonStateHandler = this.cfg.getProperty("prevButtonStateHandler"); if (prevButtonStateHandler) { this._prevButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onPrevButtonStateChange", this); this._prevButtonStateHandlerEvt.subscribe(prevButtonStateHandler, this); }
        var nextButtonStateHandler = this.cfg.getProperty("nextButtonStateHandler"); if (nextButtonStateHandler) { this._nextButtonStateHandlerEvt = new YAHOO.util.CustomEvent("onNextButtonStateChange", this); this._nextButtonStateHandlerEvt.subscribe(nextButtonStateHandler, this); }
        var visibleExtent = this._calculateVisibleExtent(); YAHOO.util.Event.onAvailable(this._carouselElemID + "-item-" +
        visibleExtent.start, this._calculateSize, this); if (this.cfg.getProperty("loadOnStart"))
            this._loadInitial();
    }, clear: function () {
        var loadInitHandler = this.cfg.getProperty("loadInitHandler"); if (loadInitHandler) { this._removeChildrenFromNode(this.carouselList); this._lastPrebuiltIdx = 0; }
        this.stopAutoPlay(); this._priorLastVisible = this._priorFirstVisible = this._origFirstVisible; this.cfg.setProperty("firstVisible", this._origFirstVisible, true); this.moveTo(this._origFirstVisible);
    }, reload: function (numVisible) {
        if (this._isValidObj(numVisible)) { this.cfg.setProperty("numVisible", numVisible); }
        this.clear(); var visibleExtent = this._calculateVisibleExtent(); YAHOO.util.Event.onAvailable(this._carouselElemID + "-item-" + visibleExtent.start, this._calculateSize, this); this._loadInitial();
    }, load: function () { var visibleExtent = this._calculateVisibleExtent(); YAHOO.util.Event.onAvailable(this._carouselElemID + "-item-" + visibleExtent.start, this._calculateSize, this); this._loadInitial(); }, addItem: function (idx, innerHTMLOrElem, itemClass) {
        if (idx > this.cfg.getProperty("size")) { return null; }
        var liElem = this.getItem(idx); if (!this._isValidObj(liElem)) { liElem = this._createItem(idx, innerHTMLOrElem); this.carouselList.appendChild(liElem); } else if (this._isValidObj(liElem.placeholder)) { var newLiElem = this._createItem(idx, innerHTMLOrElem); this.carouselList.replaceChild(newLiElem, liElem); liElem = newLiElem; }
        if (this._isValidObj(itemClass)) { YAHOO.util.Dom.addClass(liElem, itemClass); }
        if (this.isVertical())
            setTimeout(function () { liElem.style.display = "block"; }, 1); return liElem;
    }, insertBefore: function (refIdx, innerHTML) {
        if (refIdx >= this.cfg.getProperty("size")) { return null; }
        if (refIdx < 1) { refIdx = 1; }
        var insertionIdx = refIdx - 1; if (insertionIdx > this._lastPrebuiltIdx) { this._prebuildItems(this._lastPrebuiltIdx, refIdx); }
        var liElem = this._insertBeforeItem(refIdx, innerHTML); this._enableDisableControls(); return liElem;
    }, insertAfter: function (refIdx, innerHTML) {
        if (refIdx > this.cfg.getProperty("size")) { refIdx = this.cfg.getProperty("size"); }
        var insertionIdx = refIdx + 1; if (insertionIdx > this._lastPrebuiltIdx) { this._prebuildItems(this._lastPrebuiltIdx, insertionIdx + 1); }
        var liElem = this._insertAfterItem(refIdx, innerHTML); if (insertionIdx > this.cfg.getProperty("size")) { this.cfg.setProperty("size", insertionIdx, true); }
        this._enableDisableControls(); return liElem;
    }, scrollNext: function () { this._scrollNext(null, this); this._autoPlayTimer = null; if (this.cfg.getProperty("autoPlay") !== 0) { this._autoPlayTimer = this.startAutoPlay(); } }, scrollPrev: function () { this._scrollPrev(null, this); }, scrollTo: function (newStart) { this._position(newStart, true); }, moveTo: function (newStart) { this._position(newStart, false); }, startAutoPlay: function (interval) {
        if (this._isValidObj(interval)) { this.cfg.setProperty("autoPlay", interval, true); }
        if (this._autoPlayTimer !== null) { return this._autoPlayTimer; }
        var oThis = this; var autoScroll = function () { oThis.scrollNext(); }; this._autoPlayTimer = setTimeout(autoScroll, this.cfg.getProperty("autoPlay")); return this._autoPlayTimer;
    }, stopAutoPlay: function () { if (this._autoPlayTimer !== null) { clearTimeout(this._autoPlayTimer); this._autoPlayTimer = null; } }, isVertical: function () { return (this.cfg.getProperty("orientation") != "horizontal"); }, isItemLoaded: function (idx) {
        var liElem = this.getItem(idx); if (this._isValidObj(liElem) && !this._isValidObj(liElem.placeholder)) { return true; }
        return false;
    }, getItem: function (idx) { var elemName = this._carouselElemID + "-item-" + idx; var liElem = YAHOO.util.Dom.get(elemName); return liElem; }, show: function () { YAHOO.util.Dom.setStyle(this.carouselElem, "display", "block"); this.calculateSize(); }, hide: function () { YAHOO.util.Dom.setStyle(this.carouselElem, "display", "none"); }, calculateSize: function () {
        var ulKids = this.carouselList.childNodes; var li = null; for (var i = 0; i < ulKids.length; i++) { li = ulKids[i]; if (li.tagName == "LI" || li.tagName == "li") { break; } }
        var navMargin = this.cfg.getProperty("navMargin"); var numVisible = this.cfg.getProperty("numVisible"); var firstVisible = this.cfg.getProperty("firstVisible"); var pl = this._getStyleVal(li, "paddingLeft"); var pr = this._getStyleVal(li, "paddingRight"); var ml = this._getStyleVal(li, "marginLeft"); var mr = this._getStyleVal(li, "marginRight"); var pt = this._getStyleVal(li, "paddingTop"); var pb = this._getStyleVal(li, "paddingBottom"); var mt = this._getStyleVal(li, "marginTop"); var mb = this._getStyleVal(li, "marginBottom"); YAHOO.util.Dom.removeClass(this.carouselList, "carousel-vertical"); YAHOO.util.Dom.removeClass(this.carouselList, "carousel-horizontal"); if (this.isVertical()) {
            var liPaddingMarginWidth = pl + pr + ml + mr; YAHOO.util.Dom.addClass(this.carouselList, "carousel-vertical"); var liPaddingMarginHeight = pt + pb + mt + mb; var upt = this._getStyleVal(this.carouselList, "paddingTop"); var upb = this._getStyleVal(this.carouselList, "paddingBottom"); var umt = this._getStyleVal(this.carouselList, "marginTop")
            var umb = this._getStyleVal(this.carouselList, "marginBottom")
            var ulPaddingHeight = upt + upb + umt + umb; var revealAmt = (this._isExtraRevealed()) ? (this.cfg.getProperty("revealAmount") + (liPaddingMarginHeight) / 2) : 0; var liHeight = this._getStyleVal(li, "height", true); this.scrollAmountPerInc = (liHeight + liPaddingMarginHeight); var liWidth = this._getStyleVal(li, "width"); this.carouselElem.style.width = (liWidth + liPaddingMarginWidth) + "px"; this._clipReg.style.height = (this.scrollAmountPerInc * numVisible + revealAmt * 2 +
            ulPaddingHeight) + "px"; this.carouselElem.style.height = (this.scrollAmountPerInc * numVisible + revealAmt * 2 + navMargin * 2 +
            ulPaddingHeight) + "px"; var revealTop = (this._isExtraRevealed()) ? (revealAmt - (Math.abs(mt - mb) + Math.abs(pt - pb)) / 2) : 0; YAHOO.util.Dom.setStyle(this.carouselList, "position", "relative"); YAHOO.util.Dom.setStyle(this.carouselList, "top", "" + revealTop + "px"); var currY = YAHOO.util.Dom.getY(this.carouselList); YAHOO.util.Dom.setY(this.carouselList, currY - this.scrollAmountPerInc * (firstVisible - 1));
        } else {
            YAHOO.util.Dom.addClass(this.carouselList, "carousel-horizontal"); var upl = this._getStyleVal(this.carouselList, "paddingLeft"); var upr = this._getStyleVal(this.carouselList, "paddingRight"); var uml = this._getStyleVal(this.carouselList, "marginLeft")
            var umr = this._getStyleVal(this.carouselList, "marginRight")
            var ulPaddingWidth = upl + upr + uml + umr; var liMarginWidth = ml + mr; var liPaddingMarginWidth = liMarginWidth + pr + pl; var revealAmt = (this._isExtraRevealed()) ? (this.cfg.getProperty("revealAmount") + (liPaddingMarginWidth) / 2) : 0; var liWidth = li.offsetWidth; this.scrollAmountPerInc = liWidth + liMarginWidth; this._clipReg.style.width = (this.scrollAmountPerInc * numVisible + revealAmt * 2) + "px"; this.carouselElem.style.width = (this.scrollAmountPerInc * numVisible + navMargin * 2 + revealAmt * 2 +
            ulPaddingWidth) + "px"; var revealLeft = (this._isExtraRevealed()) ? (revealAmt - (Math.abs(mr - ml) + Math.abs(pr - pl)) / 2 - (uml + upl)) : 0; YAHOO.util.Dom.setStyle(this.carouselList, "position", "relative"); YAHOO.util.Dom.setStyle(this.carouselList, "left", "" + revealLeft + "px"); var currX = YAHOO.util.Dom.getX(this.carouselList); YAHOO.util.Dom.setX(this.carouselList, currX - this.scrollAmountPerInc * (firstVisible - 1));
        }
    }, setProperty: function (property, value, silent) { this.cfg.setProperty(property, value, silent); }, getProperty: function (property) { return this.cfg.getProperty(property); }, getFirstItemRevealed: function () { return this._firstItemRevealed; }, getLastItemRevealed: function () { return this._lastItemRevealed; }, getFirstVisible: function () { return this.cfg.getProperty("firstVisible"); }, getLastVisible: function () { var firstVisible = this.cfg.getProperty("firstVisible"); var numVisible = this.cfg.getProperty("numVisible"); return firstVisible + numVisible - 1; }, _getStyleVal: function (li, style, returnFloat) {
        var styleValStr = YAHOO.util.Dom.getStyle(li, style); var styleVal = returnFloat ? parseFloat(styleValStr) : parseInt(styleValStr, 10); if (style == "height" && isNaN(styleVal)) { styleVal = li.offsetHeight; } else if (isNaN(styleVal)) { styleVal = 0; }
        return styleVal;
    }, _calculateSize: function (me) { me.calculateSize(); me.show(); }, _removeChildrenFromNode: function (node) {
        if (!this._isValidObj(node))
        { return; }
        var len = node.childNodes.length; while (node.hasChildNodes())
        { node.removeChild(node.firstChild); }
    }, _prebuildLiElem: function (idx) { if (idx < 1) return; var liElem = document.createElement("li"); liElem.id = this._carouselElemID + "-item-" + idx; liElem.placeholder = true; this.carouselList.appendChild(liElem); this._lastPrebuiltIdx = (idx > this._lastPrebuiltIdx) ? idx : this._lastPrebuiltIdx; }, _createItem: function (idx, innerHTMLOrElem) {
        if (idx < 1) return; var liElem = document.createElement("li"); liElem.id = this._carouselElemID + "-item-" + idx; if (typeof (innerHTMLOrElem) === "string") { liElem.innerHTML = innerHTMLOrElem; } else { liElem.appendChild(innerHTMLOrElem); }
        return liElem;
    }, _insertAfterItem: function (refIdx, innerHTMLOrElem) { return this._insertBeforeItem(refIdx + 1, innerHTMLOrElem); }, _insertBeforeItem: function (refIdx, innerHTMLOrElem) {
        var refItem = this.getItem(refIdx); var size = this.cfg.getProperty("size"); if (size != this.UNBOUNDED_SIZE) { this.cfg.setProperty("size", size + 1, true); }
        for (var i = this._lastPrebuiltIdx; i >= refIdx; i--) { var anItem = this.getItem(i); if (this._isValidObj(anItem)) { anItem.id = this._carouselElemID + "-item-" + (i + 1); } }
        var liElem = this._createItem(refIdx, innerHTMLOrElem); var insertedItem = this.carouselList.insertBefore(liElem, refItem); this._lastPrebuiltIdx += 1; return liElem;
    }, insertAfterEnd: function (innerHTMLOrElem) { return this.insertAfter(this.cfg.getProperty("size"), innerHTMLOrElem); }, _position: function (newStart, showAnimation) { var currStart = this._priorFirstVisible; if (newStart > currStart) { var inc = newStart - currStart; this._scrollNextInc(inc, showAnimation); } else { var dec = currStart - newStart; this._scrollPrevInc(dec, showAnimation); } }, _scrollPrev: function (e, carousel) {
        if (e !== null) { carousel.stopAutoPlay(); }
        if (carousel._scrollPrevAnim.isAnimated()) { return false; }
        carousel._scrollPrevInc(carousel.cfg.getProperty("scrollInc"), (carousel.cfg.getProperty("animationSpeed") !== 0));
    }, _scrollNext: function (e, carousel) {
        if (e !== null) { carousel.stopAutoPlay(); }
        if (carousel._scrollNextAnim.isAnimated()) { return false; }
        carousel._scrollNextInc(carousel.cfg.getProperty("scrollInc"), (carousel.cfg.getProperty("animationSpeed") !== 0));
    }, _handleAnimationComplete: function (type, args, argList) { var carousel = argList[0]; var direction = argList[1]; carousel._animationCompleteEvt.fire(direction); }, _areAllItemsLoaded: function (first, last) {
        var itemsLoaded = true; for (var i = first; i <= last; i++) { var liElem = this.getItem(i); if (!this._isValidObj(liElem)) { this._prebuildLiElem(i); itemsLoaded = false; } else if (this._isValidObj(liElem.placeholder)) { itemsLoaded = false; } }
        return itemsLoaded;
    }, _prebuildItems: function (first, last) { for (var i = first; i <= last; i++) { var liElem = this.getItem(i); if (!this._isValidObj(liElem)) { this._prebuildLiElem(i); } } }, _isExtraRevealed: function () { return (this.cfg.getProperty("revealAmount") > 0); }, _scrollNextInc: function (inc, showAnimation) {
        var numVisible = this.cfg.getProperty("numVisible"); var currStart = this._priorFirstVisible; var currEnd = this._priorLastVisible; var size = this.cfg.getProperty("size"); var scrollExtent = this._calculateAllowableScrollExtent(); if (this.cfg.getProperty("wrap") && currEnd == scrollExtent.end) { this.scrollTo(scrollExtent.start); return; }
        var newStart = currStart + inc; var newEnd = newStart + numVisible - 1; if (newEnd > scrollExtent.end) { newEnd = scrollExtent.end; newStart = newEnd - numVisible + 1; }
        inc = newStart - currStart; this.cfg.setProperty("firstVisible", newStart, true); if (inc > 0) {
            if (this._isValidObj(this.cfg.getProperty("loadNextHandler"))) { var visibleExtent = this._calculateVisibleExtent(newStart, newEnd); var cacheStart = (currEnd + 1) < visibleExtent.start ? (currEnd + 1) : visibleExtent.start; var alreadyCached = this._areAllItemsLoaded(cacheStart, visibleExtent.end); this._loadNextHandlerEvt.fire(visibleExtent.start, visibleExtent.end, alreadyCached); }
            if (showAnimation) {
                var nextParams = { points: { by: [-this.scrollAmountPerInc * inc, 0] } }; if (this.isVertical()) { nextParams = { points: { by: [0, -this.scrollAmountPerInc * inc] } }; }
                this._scrollNextAnim = new YAHOO.util.Motion(this.carouselList, nextParams, this.cfg.getProperty("animationSpeed"), this.cfg.getProperty("animationMethod")); if (this.cfg.getProperty("animationCompleteHandler")) { this._scrollNextAnim.onComplete.subscribe(this._handleAnimationComplete, [this, "next"]); }
                this._scrollNextAnim.animate();
            } else { if (this.isVertical()) { var currY = YAHOO.util.Dom.getY(this.carouselList); YAHOO.util.Dom.setY(this.carouselList, currY - this.scrollAmountPerInc * inc); } else { var currX = YAHOO.util.Dom.getX(this.carouselList); YAHOO.util.Dom.setX(this.carouselList, currX - this.scrollAmountPerInc * inc); } }
        }
        this._priorFirstVisible = newStart; this._priorLastVisible = newEnd; this._enableDisableControls(); return false;
    }, _scrollPrevInc: function (dec, showAnimation) {
        var numVisible = this.cfg.getProperty("numVisible"); var currStart = this._priorFirstVisible; var currEnd = this._priorLastVisible; var size = this.cfg.getProperty("size"); var newStart = currStart - dec; var scrollExtent = this._calculateAllowableScrollExtent(); newStart = (newStart < scrollExtent.start) ? scrollExtent.start : newStart; var newEnd = newStart + numVisible - 1; if (newEnd > scrollExtent.end) { newEnd = scrollExtent.end; newStart = newEnd - numVisible + 1; }
        dec = currStart - newStart; this.cfg.setProperty("firstVisible", newStart, true); if (dec > 0) {
            if (this._isValidObj(this.cfg.getProperty("loadPrevHandler"))) { var visibleExtent = this._calculateVisibleExtent(newStart, newEnd); var cacheEnd = (currStart - 1) > visibleExtent.end ? (currStart - 1) : visibleExtent.end; var alreadyCached = this._areAllItemsLoaded(visibleExtent.start, cacheEnd); this._loadPrevHandlerEvt.fire(visibleExtent.start, visibleExtent.end, alreadyCached); }
            if (showAnimation) {
                var prevParams = { points: { by: [this.scrollAmountPerInc * dec, 0] } }; if (this.isVertical()) { prevParams = { points: { by: [0, this.scrollAmountPerInc * dec] } }; }
                this._scrollPrevAnim = new YAHOO.util.Motion(this.carouselList, prevParams, this.cfg.getProperty("animationSpeed"), this.cfg.getProperty("animationMethod")); if (this.cfg.getProperty("animationCompleteHandler")) { this._scrollPrevAnim.onComplete.subscribe(this._handleAnimationComplete, [this, "prev"]); }
                this._scrollPrevAnim.animate();
            } else {
                if (this.isVertical()) {
                    var currY = YAHOO.util.Dom.getY(this.carouselList); YAHOO.util.Dom.setY(this.carouselList, currY +
                    this.scrollAmountPerInc * dec);
                } else {
                    var currX = YAHOO.util.Dom.getX(this.carouselList); YAHOO.util.Dom.setX(this.carouselList, currX +
                    this.scrollAmountPerInc * dec);
                }
            }
        }
        this._priorFirstVisible = newStart; this._priorLastVisible = newEnd; this._enableDisableControls(); return false;
    }, _enableDisableControls: function () {
        var firstVisible = this.cfg.getProperty("firstVisible"); var lastVisible = this.getLastVisible(); var scrollExtent = this._calculateAllowableScrollExtent(); if (this._prevEnabled) { if (firstVisible === scrollExtent.start) { this._disablePrev(); } }
        if (this._prevEnabled === false) { if (firstVisible > scrollExtent.start) { this._enablePrev(); } }
        if (this._nextEnabled) { if (lastVisible === scrollExtent.end) { this._disableNext(); } }
        if (this._nextEnabled === false) { if (lastVisible < scrollExtent.end) { this._enableNext(); } }
    }, _loadInitial: function () {
        var firstVisible = this.cfg.getProperty("firstVisible"); this._priorLastVisible = this.getLastVisible(); if (this._loadInitHandlerEvt) { var visibleExtent = this._calculateVisibleExtent(firstVisible, this._priorLastVisible); var alreadyCached = this._areAllItemsLoaded(1, visibleExtent.end); this._loadInitHandlerEvt.fire(visibleExtent.start, visibleExtent.end, alreadyCached); }
        if (this.cfg.getProperty("autoPlay") !== 0) { this._autoPlayTimer = this.startAutoPlay(); }
        this._enableDisableControls();
    }, _calculateAllowableScrollExtent: function () { var scrollBeforeAmount = this.cfg.getProperty("scrollBeforeAmount"); var scrollAfterAmount = this.cfg.getProperty("scrollAfterAmount"); var size = this.cfg.getProperty("size"); var extent = { start: 1 - scrollBeforeAmount, end: size + scrollAfterAmount }; return extent; }, _calculateVisibleExtent: function (start, end) {
        if (!start) { start = this.cfg.getProperty("firstVisible"); end = this.getLastVisible(); }
        var size = this.cfg.getProperty("size"); start = start < 1 ? 1 : start; end = end > size ? size : end; var extent = { start: start, end: end }; this._firstItemRevealed = -1; this._lastItemRevealed = -1; if (this._isExtraRevealed()) {
            if (start > 1) { this._firstItemRevealed = start - 1; extent.start = this._firstItemRevealed; }
            if (end < size) { this._lastItemRevealed = end + 1; extent.end = this._lastItemRevealed; }
        }
        return extent;
    }, _disablePrev: function () {
        this._prevEnabled = false; if (this._prevButtonStateHandlerEvt) { this._prevButtonStateHandlerEvt.fire(false, this._carouselPrev); }
        if (this._isValidObj(this._carouselPrev)) { YAHOO.util.Event.removeListener(this._carouselPrev, "click", this._scrollPrev); }
    }, _enablePrev: function () {
        this._prevEnabled = true; if (this._prevButtonStateHandlerEvt) { this._prevButtonStateHandlerEvt.fire(true, this._carouselPrev); }
        if (this._isValidObj(this._carouselPrev)) { YAHOO.util.Event.addListener(this._carouselPrev, "click", this._scrollPrev, this); }
    }, _disableNext: function () {
        if (this.cfg.getProperty("wrap")) { return; }
        this._nextEnabled = false; if (this._isValidObj(this._nextButtonStateHandlerEvt)) { this._nextButtonStateHandlerEvt.fire(false, this._carouselNext); }
        if (this._isValidObj(this._carouselNext)) { YAHOO.util.Event.removeListener(this._carouselNext, "click", this._scrollNext); }
    }, _enableNext: function () {
        this._nextEnabled = true; if (this._isValidObj(this._nextButtonStateHandlerEvt)) { this._nextButtonStateHandlerEvt.fire(true, this._carouselNext); }
        if (this._isValidObj(this._carouselNext)) { YAHOO.util.Event.addListener(this._carouselNext, "click", this._scrollNext, this); }
    }, _isValidObj: function (obj) {
        if (null == obj) { return false; }
        if ("undefined" == typeof (obj)) { return false; }
        return true;
    }
};